import type { Catalogue } from "../i18n";

export const EO: Catalogue = {
  "failed": "malsukcesis",
  "saving": "konservante",
  "waiting": "atendante",
  "today": "hodiaŭ",
  "yesterday": "hieraŭ",
  "{days}d": "{days} t",
  "{weeks}w": "{weeks} s",
  "unlabeled": "sennoma",
  "clip": "klipo",
  "untagged": "sen etikedoj",
  "loading more": "ŝargante pli",
  "that's all {count}": "jen ĉiuj {count}",
  "shuffled": "miksita",
  "nothing to show": "nenio por montri",
  "chi is looking again": "chi rigardas denove",
  "chi is looking at this one next": "chi rigardos ĉi tiun sekve",
  "could not index that ref": "ne eblis indeksi tiun ref.",
  "details": "detaloj",
  "clips are not described, write your own": "klipoj ne estas priskribataj, verku vian",
  "chi left this one ({reason}), write your own": "chi lasis ĉi tiun ({reason}), verku vian",
  "chi is looking at this…": "chi rigardas tion…",
  "not described yet, write your own or tap spark": "ankoraŭ ne priskribita, verku vian aŭ tuŝu la fajreron",
  "saved": "konservita",
  "could not save the description": "ne eblis konservi la priskribon",
  "chi skips clips": "chi preterlasas klipojn",
  "described": "priskribita",
  "chi is looking": "chi rigardas",
  "skipped": "preterlasita",
  "waiting on chi": "atendante chi",
  "tagging {done}/{total} · {left} left": "etikedante {done}/{total} · restas {left}",
  "tagged {done}/{total} · {left} left": "etikeditaj {done}/{total} · restas {left}",
  "all {total} tagged": "ĉiuj {total} etikeditaj",
  "{shown} of {total}": "{shown} el {total}",
  "{count} adding": "{count} aldonataj",
  "{count} failed": "{count} malsukcesis",
  "{count} to describe": "{count} priskribendaj",
  "busy": "okupata",
  "tag": "etikedo",
  "tap + to add pictures, drop files here, or use + ref in chrome": "tuŝu + por aldoni bildojn, demetu dosierojn ĉi tie, aŭ uzu + ref en chrome",
  "every ref already has your note": "ĉiu ref. jam havas vian noton",
  "nothing matches": "nenio kongruas",
  "could not load references": "ne eblis ŝargi la referencojn",
  "all described": "ĉio priskribita",
  "could not read that file": "ne eblis legi tiun dosieron",
  "nothing usable there": "nenio uzebla tie",
  "adding {count}": "aldonante {count}",
  "could not import that file": "ne eblis importi tiun dosieron",
  "showing {tag}": "montrante {tag}",
  "chi is tagging {count} refs": "chi etikedas {count} ref.",
  "every ref is tagged": "ĉiu ref. estas etikedita",
  "could not start tagging": "ne eblis komenci etikedadon",
  "delete this reference?": "ĉu forigi ĉi tiun referencon?",
  "ref saved": "ref. konservita",
  "ref save failed": "konservo de ref. malsukcesis",
  "tagging done": "etikedado finita",
  "mode": "reĝimo",
  "tools": "iloj",
  "Tools": "Iloj",
  "Talk to Chi": "Paroli kun Chi",
  "mode tuner, drag or tap a station": "reĝima agordilo, trenu aŭ tuŝu stacion",
  "web": "retejo",
  "Tool": "Ilo",
  "Chi · direct line": "Chi · rekta linio",
  "{name}'s {what} · read only": "{what} de {name} · nur legebla",
  "could not open a print sheet": "ne eblis malfermi presfolion",
  "never": "neniam",
  "could not shrink that picture": "ne eblis malgrandigi tiun bildon",
  "could not read that picture": "ne eblis legi tiun bildon",
  "chix is processing": "chix prilaboras",
  "What should I work on next?": "Pri kio mi laboru poste?",
  "nothing yet": "ankoraŭ nenio",
  "where it came from": "de kie ĝi venis",
  "rent, phone…": "lupago, telefono…",
  "what was it": "kio ĝi estis",
  "mine": "mia",
  "{name}'s": "de {name}",
  "added to {name}'s budget": "aldonita al la buĝeto de {name}",
  "added to your budget": "aldonita al via buĝeto",
  "couldn't add that": "ne eblis aldoni tion",
  "login with discord": "ensalutu per discord",
  "minipi #{id}": "minipi n-ro {id}",
  "a minipi": "minipi",
  "{who} says": "{who} diras",
  "{who} · art tip": "{who} · arta konsilo",
  "pings": "sciigoj",
  "Late shift, {name}.": "Malfrua deĵoro, {name}.",
  "Morning, {name}.": "Bonan matenon, {name}.",
  "Ready when you are, {name}.": "Preta kiam vi pretas, {name}.",
  "Evening, {name}.": "Bonan vesperon, {name}.",
  "signal": "signalo",
  "sweet": "dolĉa",
  "edge": "akra",
  "dark fog, film grain and chi's cyan": "malhela nebulo, filmgreno kaj la cejano de chi",
  "pale daytime fog, ink and deep teal": "pala taga nebulo, inko kaj profunda bluverdo",
  "silent hill ash and an orange coal": "cindro de silent hill kaj oranĝa karbo",
  "deep water, teal fog, a sonar ping": "profunda akvo, bluverda nebulo, sonara pepo",
  "rose paper and a hot pink signal": "roza papero kaj brile rozkolora signalo",
  "peach cream and a coral signal": "persika kremo kaj korala signalo",
  "mint milk with strawberry pink": "menta lakto kun frago-rozo",
  "magical girl night, violet fog, bubblegum pink": "nokto de magia knabino, viola nebulo, maĉgumo-rozo",
  "midnight sky in periwinkle and pink": "noktomeza ĉielo en vinkoblua kaj rozo",
  "the otherworld: rust black and blood red": "la alia mondo: rusta nigro kaj sanga ruĝo",
  "night city chrome, warning yellow, red glitch": "nokta urba kromo, averta flavo, ruĝa misfunkcio",
  "bruise purple fog and acid lime": "kontuziviola nebulo kaj acida limeo",
  "pure black and white, no mercy": "pura nigro kaj blanko, sen kompato",
  "green crt, memory card manager at 2am": "verda crt, memorkarta administrilo je la 2a nokte",
  "amber crt terminal, warm glow": "sukcena crt-terminalo, varma brilo",
  "cream sketch paper and flipnote orange": "kremkolora skizpapero kaj flipnote-oranĝo",
  "grey console, blue memory card screen": "griza konzolo, blua memorkarta ekrano",
  "four shades of handheld green": "kvar nuancoj de poŝkonzola verdo",
  "none": "neniu",
  "scanlines": "skanlinioj",
  "grid": "krado",
  "dots": "punktoj",
  "notebook": "kajero",
  "checker": "ŝakpado",
  "crosshair": "krucoj",
  "sparkles": "brileroj",
  "hazard": "danĝero",
  "starry sky": "stelplena ĉielo",
  "falling leaves": "falantaj folioj",
  "sakura petals": "sakuraj petaloj",
  "snow": "neĝo",
  "rain": "pluvo",
  "fireflies": "lampiroj",
  "moves gently, stays still with calm motion": "moviĝas milde, restas senmova kun trankvila movado",
  "pattern on": "ŝablono ŝaltita",
  "theme on": "temo ŝaltita",
  "bottom": "malsupre",
  "top": "supre",
  "one clipped corner, the original look": "unu tranĉita angulo, la originala aspekto",
  "square corners everywhere": "ĉie rektaj anguloj",
  "gently rounded": "milde rondigita",
  "very round, like a handheld menu": "tre ronda, kiel menuo de portebla ludilo",
  "the original: Rajdhani titles, pixel labels": "la originalo: titoloj Rajdhani, pikselaj etikedoj",
  "your device's own system font": "la sistema tiparo de via aparato",
  "easy to read": "facile legebla",
  "Atkinson Hyperlegible, made for low vision": "Atkinson Hyperlegible, farita por malbona vidpovo",
  "dyslexia friendly": "taŭga por disleksio",
  "OpenDyslexic, weighted letter bottoms": "OpenDyslexic, literoj kun pezaj bazoj",
  "rounded": "rondigita",
  "Fredoka, soft and friendly": "Fredoka, milda kaj afabla",
  "Lora titles and text": "titoloj kaj teksto en Lora",
  "Space Mono everywhere": "Space Mono ĉie",
  "typewriter": "skribmaŝino",
  "Special Elite, inky and uneven": "Special Elite, inka kaj malebena",
  "Caveat titles, Patrick Hand text": "titoloj en Caveat, teksto en Patrick Hand",
  "DotGothic16, a psx menu face": "DotGothic16, menua tiparo de psx",
  "VT323, a green screen console": "VT323, konzolo kun verda ekrano",
  "arcade": "arkado",
  "Press Start 2P titles, pixel text": "titoloj en Press Start 2P, pikselteksto",
  "sci-fi": "sciencfikcio",
  "Orbitron titles over the original labels": "titoloj en Orbitron super la originalaj etikedoj",
  "panels you can see through, with a blur": "travidebla paneloj kun malklarigo",
  "half see through": "duone travidebla",
  "whatever the theme does": "kiel la temo faras",
  "fully opaque, easiest to read over a pattern": "tute maldiafana, plej facile legebla super motivo",
  "about 820 px of content": "ĉirkaŭ 820 px da enhavo",
  "about 1040 px of content": "ĉirkaŭ 1040 px da enhavo",
  "about 1360 px of content": "ĉirkaŭ 1360 px da enhavo",
  "use the whole screen": "uzi la tutan ekranon",
  "centred": "centrita",
  "content in the middle of the screen": "enhavo meze de la ekrano",
  "content next to the menu, spare room on the right": "enhavo apud la menuo, libera loko dekstre",
  "compact": "kompakta",
  "tighter gaps, more on screen": "pli streĉaj interspacoj, pli en la ekrano",
  "the original spacing": "la originala interspaco",
  "roomy": "ampleksa",
  "extra air around everything": "plia aero ĉirkaŭ ĉio",
  "pages sharpen into view": "paĝoj klariĝas en la vidon",
  "a plain fade": "simpla paliĝo",
  "pages rise into place": "paĝoj leviĝas al sia loko",
  "pages simply appear": "paĝoj simple aperas",
  "barely there outlines": "apenaŭ videblaj konturoj",
  "the original": "la originalo",
  "stronger outlines": "pli fortaj konturoj",
  "menu on the left": "menuo maldekstre",
  "menu on the right": "menuo dekstre",
  "radio dock at the bottom of the screen": "radia doko ĉe la fundo de la ekrano",
  "radio dock at the top of the screen": "radia doko ĉe la supro de la ekrano",
  "brighter text and stronger lines everywhere": "pli hela teksto kaj pli fortaj linioj ĉie",
  "a thick ring on whatever the keyboard has selected": "dika ringo ĉirkaŭ tio, kion la klavaro elektis",
  "loose": "vasta",
  "more space between letters, words and lines": "pli da spaco inter literoj, vortoj kaj linioj",
  "moving speckle over everything": "moviĝantaj punktetoj super ĉio",
  "the slow drifting haze behind the pages": "la malrapide drivanta nebuleto malantaŭ la paĝoj",
  "pattern strength": "forto de la motivo",
  "how strong the background pattern is, needs a pattern": "kiom forta estas la fona motivo, bezonas motivon",
  "dark edges of the screen": "malhelaj randoj de la ekrano",
  "makes everything bigger or smaller at once": "grandigas aŭ malgrandigas ĉion samtempe",
  "easy reading": "facila legado",
  "big, clear text and strong contrast": "granda, klara teksto kaj forta kontrasto",
  "cream paper, OpenDyslexic, calm": "kremkolora papero, OpenDyslexic, trankvila",
  "feel and access": "sento kaj alirebleco",
  "contrast": "kontrasto",
  "spacing": "interspaco",
  "button": "butono",
  "put back": "restarigita",
  "one tap sets the theme, pattern and the look below. yours only, it saves as you": "unu tuŝo ŝanĝas la temon, la motivon kaj la aspekton sube. nur via, konserviĝas por vi",
  "reset everything": "restarigi ĉion",
  "put the whole look back to chi signal?": "ĉu restarigi la tutan aspekton al chi signal?",
  "back to chi signal": "reen al chi signal",
  "nothing saved yet. set things up the way you like, name it and save it here": "ankoraŭ nenio konservita. aranĝu laŭ via gusto, nomu ĝin kaj konservu ĉi tie",
  "look deleted": "aspekto forigita",
  "your colours": "viaj koloroj",
  "the colour of highlights, selected buttons and the glow. it sits on top of any theme": "la koloro de reliefoj, elektitaj butonoj kaj brilo. ĝi kuŝas super ajna temo",
  "background colour": "fona koloro",
  "your own screen colour instead of the theme's. text and contrast follow on their own": "via propra ekrankoloro anstataŭ tiu de la temo. teksto kaj kontrasto sekvas mem",
  "switch themes by itself when this device goes light or dark": "ŝanĝas temon mem kiam ĉi tiu aparato iĝas hela aŭ malhela",
  "off keeps the theme you pick above all day": "malŝaltita tenas la supre elektitan temon tutan tagon",
  "in light mode": "en hela reĝimo",
  "in dark mode": "en malhela reĝimo",
  "how panels, buttons and cards are shaped": "kiel paneloj, butonoj kaj kartoj formiĝas",
  "the typeface for titles, labels and text. every one is bundled, nothing is downloaded from outside": "la tiparo por titoloj, etikedoj kaj teksto. ĉiuj estas enkonstruitaj, nenio elŝutiĝas de ekstere",
  "panel glass": "vitro de paneloj",
  "how see-through panels are over the background": "kiom travidebla estas paneloj super la fono",
  "outlines": "konturoj",
  "how strong the thin lines around things are": "kiom fortaj estas la maldikaj linioj ĉirkaŭ aĵoj",
  "off writes labels in normal lower case, easier to read": "malŝaltita skribas etikedojn per normalaj malgrandaj literoj, pli facile legeblaj",
  "background effects": "fonaj efektoj",
  "film grain and fog are switched off on this device, so those two sliders have nothing to move": "filmgrajno kaj nebulo estas malŝaltitaj sur ĉi tiu aparato, do tiuj du ŝoviloj nenion movas",
  "turn them on": "ŝalti ilin",
  "grain and fog on": "grajno kaj nebulo ŝaltitaj",
  "off on this device, turn it on above": "malŝaltita sur ĉi tiu aparato, ŝaltu ĝin supre",
  "pick a pattern above and this will change how strong it is": "elektu motivon supre kaj ĉi tio ŝanĝos ĝian forton",
  "grain and fog on this device": "grajno kaj nebulo sur ĉi tiu aparato",
  "this switch is for this browser only. use it to calm a busy screen or a slow device": "ĉi tiu ŝaltilo validas nur por ĉi tiu retumilo. uzu ĝin por kvietigi okupatan ekranon aŭ malrapidan aparaton",
  "how wide the page content gets. it only shows on screens wider than the setting, so on a phone nothing changes": "kiom larĝa fariĝas la paĝa enhavo. ĝi videblas nur sur ekranoj pli larĝaj ol la agordo, do sur telefono nenio ŝanĝiĝas",
  "page position": "loko de la paĝo",
  "where the content sits on wide screens": "kie la enhavo staras sur larĝaj ekranoj",
  "how close or far apart things sit": "kiom proksime aŭ malproksime aĵoj staras",
  "menu side, tablets and computers": "flanko de la menuo, tabulkomputiloj kaj komputiloj",
  "which side the menu with the dial sits on, on screens wider than 900 px": "sur kiu flanko estas la menuo kun la ciferdisko, sur ekranoj pli larĝaj ol 900 px",
  "dock position, phones": "loko de la doko, telefonoj",
  "where the radio dock sits on phones and portrait tablets": "kie la radia doko estas sur telefonoj kaj starantaj tabulkomputiloj",
  "the motion as you switch pages": "la movo kiam vi ŝanĝas paĝojn",
  "size and comfort": "grandeco kaj komforto",
  "brighter text and stronger lines": "pli hela teksto kaj pli fortaj linioj",
  "keyboard focus ring": "klavara fokusa ringo",
  "how clearly the selected control is marked when you use the keyboard": "kiom klare la elektita stirilo estas markita kiam vi uzas la klavaron",
  "text spacing": "teksta interspaco",
  "more room between letters, words and lines, kinder on tired eyes": "pli da spaco inter literoj, vortoj kaj linioj, milda por lacaj okuloj",
  "turn off the quick flicker when a page opens": "malŝaltas la rapidan flagradon kiam paĝo malfermiĝas",
  "stops the fog, falling pieces and most movement on this device": "haltigas la nebulon, la falantajn pecojn kaj plejparton de la moviĝo sur ĉi tiu aparato",
  "this device only": "nur ĉi tiu aparato",
  "a short beep when you press a button, like a console menu": "mallonga bipo kiam vi premas butonon, kiel en menuo de ludkonzolo",
  "sounds off": "sonoj malŝaltitaj",
  "sounds on": "sonoj ŝaltitaj",
  "tap effect": "tuŝa efekto",
  "what appears where you touch the screen": "kio aperas kie vi tuŝas la ekranon",
  "tap effect off": "tuŝa efekto malŝaltita",
  "tap effect on": "tuŝa efekto ŝaltita",
  "put this page back": "restarigi ĉi tiun paĝon",
  "chip": "peceto",
  "preview": "antaŭrigardo",
  "the quick brown fox jumps over the lazy dog": "la rapida bruna vulpo saltas super la mallaborema hundo",
  "look settings": "aspektaj agordoj",
  "a faint pattern behind the pages. the animated ones stay still with calm motion": "malforta motivo malantaŭ la paĝoj. la moviĝantaj restas senmovaj kun kvieta moviĝo",
  "left side": "maldekstra flanko",
  "right side": "dekstra flanko",
  "one tap sets the theme, pattern and everything below. yours only, it saves as you": "unu tuŝo ŝanĝas la etoson, la ŝablonon kaj ĉion sube. nur via, konservita sub via nomo",
  "your looks": "viaj aspektoj",
  "delete this look?": "ĉu forigi ĉi tiun aspekton?",
  "delete this look": "forigi ĉi tiun aspekton",
  "name this look": "nomu ĉi tiun aspekton",
  "save current look": "konservi la nunan aspekton",
  "surprise me": "surprizu min",
  "reset look": "restarigi aspekton",
  "put the look back to chi signal?": "ĉu restarigi la aspekton chi signal?",
  "my look": "mia aspekto",
  "look code": "aspekta kodo",
  "copy my code": "kopii mian kodon",
  "use this code": "uzi ĉi tiun kodon",
  "button sounds": "butonaj sonoj",
  "where you tap": "kie vi tuŝas",
  "the theme's own": "la propra de la etoso",
  "pick any colour": "elektu ajnan koloron",
  "that is the most looks you can keep, delete one first": "tio estas la maksimumo da aspektoj, forigu unu unue",
  "look saved": "aspekto konservita",
  "share a look": "kunhavigi aspekton",
  "copy your code and send it to anyone. paste theirs here and press use to wear it": "kopiu vian kodon kaj sendu al iu ajn. algluu ilian ĉi tie kaj premu uzi por surmeti ĝin",
  "code copied": "kodo kopiita",
  "code selected, copy it by hand": "kodo elektita, kopiu mane",
  "that is not a look code": "tio ne estas aspekta kodo",
  "look on": "aspekto ŝaltita",
  "rolled a new look": "hazarda nova aspekto",
  "look reset": "aspekto restarigita",
  "this device": "ĉi tiu aparato",
  "sound and taps are kept on this browser only, grain and calm motion are above": "sono kaj tuŝoj estas konservitaj nur en ĉi tiu retumilo, greno kaj trankvila movo estas supre",
  "colours": "koloroj",
  "an accent over any theme, and an optional background of your own. text and tone follow on their own": "akcento super ajna etoso, kaj propra fono se vi volas. teksto kaj tono sekvas mem",
  "shape and type": "formo kaj tiparo",
  "accent": "akcento",
  "corners": "anguloj",
  "font": "tiparo",
  "panels": "paneloj",
  "capital letters on labels": "majuskloj sur etikedoj",
  "atmosphere": "etoso",
  "how much fog, grain and pattern sit behind everything. grain and fog also need the switch below": "kiom da nebulo, greno kaj ŝablono estas malantaŭ ĉio. greno kaj nebulo ankaŭ bezonas la ŝaltilon sube",
  "layout and motion": "aranĝo kaj movo",
  "page width": "paĝa larĝo",
  "rail side, on tablets and desktops": "flanko de la fervojo, sur tabulkomputiloj kaj labortabloj",
  "when a page opens": "kiam paĝo malfermiĝas",
  "station worlds": "mondoj de stacioj",
  "each station gets its own colour, moving backdrop and a title that locks in when a page opens": "ĉiu stacio havas sian koloron, moviĝantan fonon kaj titolon kiu ŝlosiĝas kiam paĝo malfermiĝas",
  "tilt and magnetic": "klino kaj magneto",
  "tiles lean toward your finger or pointer and main buttons pull toward the cursor": "kaheloj klinas al via fingro aŭ montrilo kaj ĉefaj butonoj tiriĝas al la kursoro",
  "glitch on page titles": "glitĉo sur paĝaj titoloj",
  "day and night": "tago kaj nokto",
  "switch themes with this device's light or dark setting": "ŝanĝi etosojn laŭ la hela aŭ malhela agordo de ĉi tiu aparato",
  "follow the device": "sekvi la aparaton",
  "light mode": "hela reĝimo",
  "dark mode": "malhela reĝimo",
  "cut": "tranĉita",
  "sharp": "akra",
  "round": "ronda",
  "clean": "pura",
  "pixel": "pikselo",
  "handwritten": "manskribita",
  "clear glass": "klara vitro",
  "frosted": "frosta",
  "theme": "etoso",
  "solid": "solida",
  "narrow": "mallarĝa",
  "full": "plena",
  "blur in": "malklariĝa enveno",
  "fade": "paliĝo",
  "slide up": "gliti supren",
  "faint": "pala",
  "bold": "grasa",
  "right": "dekstre",
  "film grain": "filmgreno",
  "pattern": "ŝablono",
  "vignette": "vinjeto",
  "interface size": "grando de interfaco",
  "blip": "bipo",
  "click": "klako",
  "ripple": "ondeto",
  "spark": "fajrero",
  "chi signal": "chi signal",
  "the original, untouched": "la originalo, neŝanĝita",
  "silent hill": "silent hill",
  "ember, heavy fog and grain": "ardaĵo, peza nebulo kaj greno",
  "flipnote": "flipnote",
  "sketch paper, handwriting, soft corners": "skizpapero, mana skribo, mildaj anguloj",
  "memory card": "memorkarto",
  "psx grey, pixel type, sharp": "psx-griza, pikselaj literoj, akra",
  "magical girl": "magia knabino",
  "lilac night, sparkles, round": "lila nokto, briletoj, ronda",
  "dsi menu": "dsi-menuo",
  "glossy white, rounded, clean": "brila blanko, rondigita, pura",
  "terminal": "terminalo",
  "green crt, monospace, no frills": "verda crt, egallarĝa, sen ornamoj",
  "the rain": "la pluvo",
  "code rain on black": "koda pluvo sur nigro",
  "night city": "nokta urbo",
  "warning yellow, hazard stripes": "averta flavo, danĝeraj strioj",
  "cozy afternoon": "komforta posttagmezo",
  "peach cream and falling petals": "persika kremo kaj falantaj petaloj",
  "midnight forest": "noktomeza arbaro",
  "moss and fireflies": "musko kaj lampiroj",
  "mall soft": "mola butikcentro",
  "vapor pink and cyan edge": "vapor-rozo kaj cejana rando",
  "drafting table": "desegna tablo",
  "blueprint, grid and mono": "blua kopio, krado kaj egallarĝa",
  "blue screen": "blua ekrano",
  "a very polite crash": "tre ĝentila paneo",
  "deep sea": "profunda maro",
  "abyss and slow bubbles": "abismo kaj malrapidaj vezikoj",
  "quiet paper": "trankvila papero",
  "light, calm, no effects": "hela, trankvila, sen efektoj",
  "nature": "naturo",
  "sunset": "sunsubiro",
  "dusk violet and a burnt orange sun": "krepuska viola kaj bruloranĝa suno",
  "forest": "arbaro",
  "moss, wet bark and leaf green": "musko, malseka ŝelo kaj foliverda",
  "coffee": "kafo",
  "espresso brown and crema": "espresa bruno kaj kremo",
  "ice": "glacio",
  "frozen pale blue and deep water ink": "frosta pala bluo kaj inko de profunda akvo",
  "matcha": "matĉo",
  "soft green tea and a dark leaf": "mola verda teo kaj malhela folio",
  "vapor": "vapor",
  "late night mall, pink on purple with a cyan edge": "noktomeza butikcentro, rozo sur purpuro kun cejana rando",
  "bsod": "bsod",
  "a blue screen, white text, nothing to hide": "blua ekrano, blanka teksto, nenio kaŝenda",
  "blueprint": "blua kopio",
  "cyan ink on drafting blue": "cejana inko sur desegna bluo",
  "dsi": "dsi",
  "glossy white handheld and its blue menu": "brila blanka porteblo kaj ĝia blua menuo",
  "waves": "ondoj",
  "honeycomb": "abelĉelaro",
  "diamonds": "rombo",
  "cross stitch": "kruceto",
  "embers": "brasoj",
  "bubbles": "vezikoj",
  "code rain": "koda pluvo",
  "saved, type to replace": "konservita, tajpu por anstataŭigi",
  "not set": "ne agordita",
  "token copied": "ĵetono kopiita",
  "make a new extension token? the old one stops working until you paste the new one in": "ĉu krei novan kromprograman ĵetonon? la malnova ĉesas funkcii ĝis vi algluos la novan",
  "new token made": "nova ĵetono kreita",
  "log out of chix on every device?": "ĉu elsaluti el chix en ĉiu aparato?",
  "auto": "aŭtomate",
  "€ euro": "€ eŭro",
  "$ dollar": "$ dolaro",
  "£ pound": "£ pundo",
  "¥ yen": "¥ eno",
  "C$ canadian": "C$ kanada",
  "A$ australian": "A$ aŭstralia",
  "CHF swiss franc": "CHF svisa franko",
  "talking to plane": "parolante kun plane",
  "connected to {workspace}, now pick your boards": "konektita al {workspace}, nun elektu viajn tabulojn",
  "open plane": "malfermi plane",
  "in safari, create an api token in profile settings, paste it below, then save": "en safari, kreu api-ĵetonon en profilaj agordoj, algluu ĝin sube, poste konservu",
  "couldn't do that": "ne eblis fari tion",
  "google turned the map key away. check it's allowed on this site and maps javascript api is on": "google rifuzis la mapan ŝlosilon. kontrolu ke ĝi estas permesita ĉe ĉi tiu retejo kaj ke maps javascript api estas ŝaltita",
  "the map needs a key to draw, searches and routes still work below": "la mapo bezonas ŝlosilon por montriĝi, serĉoj kaj itineroj ankoraŭ funkcias sube",
  "the map couldn't load. searches and routes still work below": "la mapo ne povis ŝargiĝi. serĉoj kaj itineroj ankoraŭ funkcias sube",
  "you": "vi",
  "new pin": "nova pinglo",
  "open now": "nun malfermita",
  "closed now": "nun fermita",
  "new": "nova",
  "{rating} from 1 review": "{rating} el 1 recenzo",
  "{rating} from {count} reviews": "{rating} el {count} recenzoj",
  "no reviews yet": "ankoraŭ neniuj recenzoj",
  "no parking info": "neniu informo pri parkado",
  "no parking listed": "neniu parkejo listigita",
  "pin": "pinglo",
  "{place} is stop {letter}": "{place} estas haltejo {letter}",
  "save": "konservi",
  "looking…": "serĉante…",
  "nothing found there. try further out or other words": "nenio trovita tie. provu pli malproksime aŭ aliajn vortojn",
  "pick something to look for, or search above": "elektu ion por serĉi, aŭ serĉu supre",
  "{what} within {distance} of {place}": "{what} ene de {distance} de {place}",
  "around {place}": "ĉirkaŭ {place}",
  "ten stops is the most": "dek haltejoj estas la maksimumo",
  "taken out of saved": "forigita el konservitaj",
  "remove {name}?": "forigi {name}?",
  "nothing saved yet": "ankoraŭ nenio konservita",
  "tap the map": "tuŝu la mapon",
  "drop a pin": "meti pinglon",
  "edit {name}": "redakti {name}",
  "save pin": "konservi pinglon",
  "my pin": "mia pinglo",
  "pinned": "pinglita",
  "places, ratings, parking and routes come from google maps. it needs a key from your google cloud account, google gives a free allowance each month": "lokoj, taksoj, parkado kaj itineroj venas el google maps. ĝi bezonas ŝlosilon el via google cloud-konto, google donas senpagan kvoton ĉiumonate",
  "fractal hasn't added a google maps key yet, so the map can't look anything up": "fractal ankoraŭ ne aldonis google maps-ŝlosilon, do la mapo ne povas serĉi ion ajn",
  "within {distance}": "ene de {distance}",
  "this area": "ĉi tiu areo",
  "couldn't find where you are, staying around {place}": "ne eblis trovi kie vi estas, restante ĉirkaŭ {place}",
  "cyan": "cejana",
  "violet": "viola",
  "amber": "sukceno",
  "green": "verda",
  "red": "ruĝa",
  "tap the map where the pin goes": "tuŝu la mapon kie la pinglo iru",
  "couldn't find where you are": "ne eblis trovi kie vi estas",
  "take this pin off the map?": "forpreni ĉi tiun pinglon de la mapo?",
  "where i am": "kie mi estas",
  "home ({place})": "hejmo ({place})",
  "name this route": "nomu ĉi tiun itineron",
  "{from} to {to}": "{from} al {to}",
  "route saved": "itinero konservita",
  "food": "manĝaĵo",
  "cafés": "kafejoj",
  "pubs and bars": "drinkejoj kaj trinkejoj",
  "takeaway": "forportaĵoj",
  "shops": "butikoj",
  "fuel": "brulaĵo",
  "parking": "parkejo",
  "pharmacy": "apoteko",
  "parks": "parkoj",
  "things to see": "vidindaĵoj",
  "cinema": "kinejo",
  "ev charging": "ŝargado de elektraŭtoj",
  "drive": "aŭto",
  "walk": "piede",
  "cycle": "biciklo",
  "bus/train": "buso/trajno",
  "{amount} a month": "{amount} monate",
  "by {date}": "ĝis {date}",
  "monthly, stopped {date}": "monata, haltigita {date}",
  "monthly from {date}": "monata ekde {date}",
  "on {date}": "je {date}",
  "added by you": "aldonita de vi",
  "added by {name}": "aldonita de {name}",
  "{done} paid of {total} · {left} left": "{done} pagita el {total} · restas {left}",
  "paid off · {total}": "tute pagita · {total}",
  "{done} saved of {total} · {left} to go": "{done} ŝparita el {total} · restas {left}",
  "reached · {done}": "atingita · {done}",
  "in": "enspezo",
  "bill": "fakturo",
  "cost": "kosto",
  "debt": "ŝuldo",
  "goal": "celo",
  "remove {name}? its history goes too": "forigi {name}? ĝia historio ankaŭ foriros",
  "restart": "restartigi",
  "stop": "halti",
  "paid": "pagita",
  "payment logged": "pago registrita",
  "saved toward it": "ŝparita por ĝi",
  "took back the last one": "malfaris la lastan",
  "{amount} left": "restas {amount}",
  "{amount} saved": "{amount} ŝparita",
  "out": "elspezoj",
  "no monthly bills yet": "ankoraŭ neniuj monataj fakturoj",
  "owe": "ŝuldo",
  "{percent}% of {total}": "{percent}% el {total}",
  "{amount} this month": "{amount} ĉi-monate",
  "owed in total": "ŝuldata entute",
  "target": "celsumo",
  "a month (optional)": "monate (nedeviga)",
  "how much comes in": "kiom envenas",
  "how much": "kiom",
  "by": "ĝis",
  "since": "ekde",
  "from": "de",
  "on": "je",
  "where it comes from": "de kie ĝi venas",
  "rent, phone, adobe…": "lupago, telefono, adobe…",
  "what you bought": "kion vi aĉetis",
  "who or what you owe": "al kiu aŭ kion vi ŝuldas",
  "what you're saving for": "por kio vi ŝparas",
  "add": "aldoni",
  "add to the budget": "aldoni al la buĝeto",
  "added": "aldonita",
  "couldn't save that": "ne eblis konservi tion",
  "due: {title}": "limdato: {title}",
  "unexpected \"{char}\"": "neatendita \"{char}\"",
  "missing )": "mankas )",
  "expected a number": "nombro atendita",
  "that goes to infinity": "tio iras al senfineco",
  "not set, add it in setup": "ne agordita, aldonu ĝin en agordoj",
  "{spent} of {budget} for tagging": "{spent} el {budget} por etikedado",
  "no cap on tagging": "neniu limo por etikedado",
  "{count} refs waiting since {time}": "{count} ref. atendas ekde {time}",
  "none running": "nenio funkcias",
  "{calls} calls · {input} in · {cached} cached · {output} out": "{calls} vokoj · {input} enen · {cached} kaŝmemorite · {output} el",
  "nothing yet for {month}": "ankoraŭ nenio por {month}",
  "{calls} calls": "{calls} vokoj",
  "split starts with the next answer": "la divido komenciĝas per la sekva respondo",
  "could not read claude usage": "ne eblis legi la uzon de claude",
  "all": "ĉio",
  "start {name}?": "starti {name}?",
  "starting {name}...": "startigante {name}...",
  "{name} start sent": "starto de {name} sendita",
  "stop {name}?": "haltigi {name}?",
  "stopping {name}...": "haltigante {name}...",
  "{name} stop sent": "halto de {name} sendita",
  "restart {name}?": "restartigi {name}?",
  "restarting {name}...": "restartigante {name}...",
  "{name} restart sent": "restarto de {name} sendita",
  "running": "funkcias",
  "stopped": "haltigita",
  "crash looping": "kraŝas ripete",
  "starting": "startiĝas",
  "up {time}": "funkcias dum {time}",
  "{count} restarts": "{count} restartoj",
  "{name} logs": "protokoloj de {name}",
  "loading...": "ŝargante...",
  "{used} of {total}": "{used} el {total}",
  "could not reach the server: {error}": "ne eblis atingi la servilon: {error}",
  "validating caddy...": "validigante caddy...",
  "caddy reloaded": "caddy reŝargita",
  "{label}, one per line": "{label}, po unu en linio",
  "change picture": "ŝanĝi bildon",
  "all {n}": "ĉio {n}",
  "unsorted": "neordigitaj",
  "under a cent": "malpli ol cendo",
  "chi looking {done}/{total}": "chi rigardas {done}/{total}",
  "chi look {done}/{total}": "chi rigardu {done}/{total}",
  "chi looked": "chi rigardis",
  "chi has looked at every character picture": "chi jam rigardis ĉiujn bildojn de roluloj",
  "{n} more wait for another press.": "{n} pliaj atendas alian premon.",
  "chi has looked at {done} of {total} character pictures. look at the next {count} for about {price}? it goes through the half price batch, so it can take a while.": "chi rigardis {done} el {total} bildoj de roluloj. ĉu rigardi la sekvajn {count} por ĉirkaŭ {price}? ĝi iras tra la duonpreza aro, do ĝi povas daŭri iom.",
  "chi is looking at {count} pictures": "chi rigardas {count} bildojn",
  "could not start chi": "ne eblis lanĉi chi",
  "chi looks at 1 picture of {name} she hasn't seen, about {price}?": "ĉu chi rigardu 1 bildon de {name} kiun ŝi ne vidis, por ĉirkaŭ {price}?",
  "chi looks at {count} pictures of {name} she hasn't seen, about {price}?": "ĉu chi rigardu {count} bildojn de {name} kiujn ŝi ne vidis, por ĉirkaŭ {price}?",
  "chi has seen all {total} pictures of {name}. look at them again from scratch, about {price}?": "chi jam vidis ĉiujn {total} bildojn de {name}. ĉu rigardi ilin denove de la komenco, por ĉirkaŭ {price}?",
  "chi is looking at {name}": "chi rigardas {name}",
  "picture {n}": "bildo {n}",
  "adding 1 picture…": "aldonante 1 bildon…",
  "adding {n} pictures…": "aldonante {n} bildojn…",
  "picture added": "bildo aldonita",
  "{n} pictures added": "{n} bildoj aldonitaj",
  "could not add the picture": "ne eblis aldoni la bildon",
  "take this picture off the character?": "ĉu forpreni ĉi tiun bildon de la rolulo?",
  "picture removed": "bildo forigita",
  "could not remove the picture": "ne eblis forigi la bildon",
  "sheet picture changed": "bildo de la folio ŝanĝita",
  "could not change the picture": "ne eblis ŝanĝi la bildon",
  "fetching characters from {source}…": "venigante rolulojn el {source}…",
  "{n} found": "{n} trovitaj",
  "{n} added": "{n} aldonitaj",
  "{n} updated": "{n} ĝisdatigitaj",
  "{n} duplicates merged": "{n} duoblaĵoj kunfanditaj",
  "{n} failed": "{n} malsukcesis",
  "{source} import failed": "importo el {source} malsukcesis",
  "aka {names}": "alinome {names}",
  "{n} pictures": "{n} bildoj",
  "merge into {name}": "kunfandi en {name}",
  "merge {other} into {name}? {other}'s sheet goes away and its pictures move to {name}.": "ĉu kunfandi {other} en {name}? la folio de {other} malaperas kaj ĝiaj bildoj moviĝas al {name}.",
  "{other} merged into {name}": "{other} kunfandita en {name}",
  "the sheet": "la folio",
  "could not merge": "ne eblis kunfandi",
  "character saved": "rolulo konservita",
  "could not save": "ne eblis konservi",
  "delete {name}?": "ĉu forigi {name}?",
  "1 block today": "1 bloko hodiaŭ",
  "{n} blocks today": "{n} blokoj hodiaŭ",
  "resume": "daŭrigi",
  "back to drawing": "reen al desegnado",
  "break time, stretch your hand": "paŭzo, streĉu vian manon",
  "focus block started": "koncentra bloko komenciĝis",
  "take a break": "paŭzu",
  "type minutes, like 40 or 1h30": "tajpu minutojn, ekz. 40 aŭ 1h30",
  "drop this picture": "forigi ĉi tiun bildon",
  "toss {hex}?": "ĉu forĵeti {hex}?",
  "copied {hex}": "{hex} kopiita",
  "prompt copied": "prompto kopiita",
  "commissions": "mendoj",
  "no commissions": "neniuj mendoj",
  "comms money": "mon-enspezo de mendoj",
  "{n} paid": "{n} pagitaj",
  "{n} others": "{n} aliaj",
  "nothing paid yet": "ankoraŭ nenio pagita",
  "that task is done or gone": "tiu tasko estas farita aŭ forigita",
  "unlink {title}": "malligi {title}",
  "no task matches": "neniu tasko kongruas",
  "no open tasks. add one in tasks first": "neniuj malfermitaj taskoj. unue aldonu unu en taskoj",
  "for {client}": "por {client}",
  "paid {day}": "pagita {day}",
  "due {date}": "limdato {date}",
  "commission saved": "mendo konservita",
  "commission added": "mendo aldonita",
  "break": "paŭzo",
  "unknown": "nekonata",
  "fapped {n} times": "fap {n} fojojn",
  "no doodles match": "neniu skribaĉo kongruas",
  "could not load the doodles": "ne eblis ŝargi la skribaĉojn",
  "no picture on the clipboard": "neniu bildo en la tondujo",
  "pick a picture": "elektu bildon",
  "you can look at the doodles, not add them": "vi povas rigardi la skribaĉojn, ne aldoni ilin",
  "adding the doodle": "aldonante la skribaĉon",
  "adding {n} of {total}": "aldonante {n} el {total}",
  "{n} doodles added": "{n} skribaĉoj aldonitaj",
  "could not add that": "ne eblis aldoni tion",
  "press ctrl+v or ⌘v to paste": "premu ctrl+v aŭ ⌘v por alglui",
  "couldn't read the clipboard, try ctrl+v or ⌘v": "ne eblis legi la tondujon, provu ctrl+v aŭ ⌘v",
  "gone": "forigita",
  "remove {name}": "forigi {name}",
  "new doodle": "nova skribaĉo",
  "doodle saved": "skribaĉo konservita",
  "delete this doodle?": "ĉu forigi ĉi tiun skribaĉon?",
  "could not delete": "ne eblis forigi",
  "by {name}": "de {name}",
  "one a day per doodle, come back tomorrow": "unu tage por ĉiu skribaĉo, revenu morgaŭ",
  "today ✓ {n}": "hodiaŭ ✓ {n}",
  "fapped {n}×": "fap {n}×",
  "you {n}": "vi {n}",
  "could not count that": "ne eblis kalkuli tion",
  "random full body poses from the pocketbase library": "hazardaj tutkorpaj pozoj el la pocketbase-biblioteko",
  "{n} refs in the pool": "{n} ref. en la aro",
  "no refs match yet": "ankoraŭ neniu ref. kongruas",
  "could not fetch poses": "ne eblis venigi pozojn",
  "play": "ludi",
  "no poses to draw from": "neniuj pozoj por desegni",
  "{n} poses done, nice": "{n} pozoj faritaj, bonege",
  "{n} answered today": "{n} responditaj hodiaŭ",
  "{n} day streak": "{n}-taga serio",
  "nothing due right now, {n} learning cards come back in {minutes}m": "nenio nun, {n} lernataj kartoj revenos post {minutes}m",
  "today's cards are done, see you tomorrow": "la hodiaŭaj kartoj estas faritaj, ĝis morgaŭ",
  "no cards to study, switch a deck on below": "neniuj kartoj por studi, ŝaltu kartaron sube",
  "{seen} of {total} seen · {solid} solid": "{seen} el {total} viditaj · {solid} firmaj",
  "study {deck}": "studi {deck}",
  "could not load the deck": "ne eblis ŝargi la kartaron",
  "could not save that answer": "ne eblis konservi tiun respondon",
  "could not save the deck setup": "ne eblis konservi la agordojn de la kartaro",
  "basics": "bazaĵoj",
  "favourites": "plej ŝatataj",
  "likes and goals": "ŝatoj kaj celoj",
  "looks": "aspekto",
  "identity": "identeco",
  "sexuality": "sekseco",
  "story": "rakonto",
  "for chi": "por chi",
  "orientation": "orientiĝo",
  "trivia": "kuriozaĵoj",
  "created by": "kreita de",
  "world": "mondo",
  "location": "loko",
  "race": "raso",
  "occupation": "okupo",
  "gender": "genro",
  "height": "alteco",
  "favourite food": "plej ŝatata manĝaĵo",
  "smell": "odoro",
  "pet peeve": "ĝenaĵo",
  "likes": "ŝatoj",
  "dislikes": "malŝatoj",
  "look in short": "aspekto mallonge",
  "body": "korpo",
  "clothes": "vestaĵoj",
  "visual features": "vidaj trajtoj",
  "speaking": "parolmaniero",
  "personality": "personeco",
  "relationships": "rilatoj",
  "items": "objektoj",
  "skills": "kapabloj",
  "preferences": "preferoj",
  "fetishes": "fetiĉoj",
  "sexual trivia": "seksaj kuriozaĵoj",
  "rpg sheet": "rolludo-folio",
  "fractal's notes for chi": "notoj de fractal por chi",
  "sees your {kinds}": "vidas viajn {kinds}",
  "sees nothing of yours": "vidas nenion vian",
  "{line}, adds to your {kinds}": "{line}, aldonas al viaj {kinds}",
  "{name} can add to your {kind}": "{name} povas aldoni al viaj {kind}",
  "{name} can only read your {kind}": "{name} povas nur legi viajn {kind}",
  "{name} can see your {kind}": "{name} povas vidi viajn {kind}",
  "{kind} hidden from {name}": "{kind} kaŝitaj de {name}",
  "{name} can see everything you can share": "{name} povas vidi ĉion, kion vi povas kunhavigi",
  "{name} sees nothing of yours now": "{name} nun vidas nenion vian",
  "share {kind} with {name}": "kunhavigi {kind} kun {name}",
  "you don't have notes, pings or anything else to share yet": "vi ankoraŭ ne havas notojn, sciigojn aŭ ion ajn por kunhavigi",
  "share all": "kunhavigi ĉion",
  "share none": "kunhavigi nenion",
  "nobody else is in chix yet": "neniu alia estas en chix ankoraŭ",
  "shares their {kinds}": "kunhavigas siajn {kinds}",
  "Calendar events": "Kalendaraj eventoj",
  "Places and routes": "Lokoj kaj itineroj",
  "your sticky notes": "viaj glunotoj",
  "reminders, alarms and timers": "memorigiloj, alarmoj kaj tempumiloj",
  "your own events on the month": "viaj propraj eventoj de la monato",
  "plane and chix bot": "plane kaj chix-roboto",
  "clients, prices, status, linked tasks and money stats": "klientoj, prezoj, stato, ligitaj taskoj kaj monstatistikoj",
  "bills, costs, debts and goals": "fakturoj, kostoj, ŝuldoj kaj celoj",
  "what you keep up and your streaks": "kion vi daŭrigas kaj viaj serioj",
  "spots and routes you saved on the map": "lokoj kaj itineroj, kiujn vi konservis sur la mapo",
  "Can add to it": "Povas aldoni",
  "bills, costs, money in and payments, with their name on them. they can change only what they added": "fakturoj, kostoj, enspezoj kaj pagoj, kun ilia nomo. ili povas ŝanĝi nur tion, kion ili aldonis",
  "off": "malŝaltita",
  "{on} of {total} on · chi {spent} of {cap}": "{on} el {total} ŝaltitaj · chi {spent} el {cap}",
  "{on} of {total} on · chi {spent}": "{on} el {total} ŝaltitaj · chi {spent}",
  "{feature} off for {name}": "{feature} malŝaltita por {name}",
  "{name} can view {feature}": "{name} povas vidi {feature}",
  "{name} can edit {feature}": "{name} povas redakti {feature}",
  "{feature} for {name}": "{feature} por {name}",
  "monthly chi cap, usd": "monata chi-limo, usd",
  "{name}'s chi stops at {amount} a month": "la chi de {name} haltas ĉe {amount} monate",
  "no cap for {name}": "neniu limo por {name}",
  "{spent} over {count} answers this month. 0 means no cap": "{spent} por {count} respondoj ĉi-monate. 0 signifas neniun limon",
  "remove {name}? they get signed out. their own notes and chats stay on the server if you add them back": "ĉu forigi {name}? ri estos elsalutigita. riaj notoj kaj babiloj restas en la servilo, se vi re-aldonos rin",
  "{name} removed": "{name} forigita",
  "just you for now": "nur vi nuntempe",
  "{name} can sign in now. they start with chi, notes, pings and routines": "{name} nun povas ensaluti. ri komencas kun chi, notoj, sciigoj kaj rutinoj",
  "Calendar and pings": "Kalendaro kaj sciigoj",
  "Chi speaker": "Chi-laŭtparolilo",
  "Discord messages": "Discord-mesaĝoj",
  "Keys and server setup": "Ŝlosiloj kaj servilaj agordoj",
  "their own chat and memory, on your claude account": "ria propra babilo kaj memoro, per via claude-konto",
  "the shared ref library": "la komuna ref.-biblioteko",
  "the shared oc sheets": "la komunaj oc-folioj",
  "their own": "siaj propraj",
  "plane and chix bot, their own": "plane kaj chix-roboto, siaj propraj",
  "timer, palette, prompts, comms and their money stats": "tempumilo, paletro, ideoj, mendoj kaj siaj monstatistikoj",
  "their own bills, costs, debts and goals": "siaj propraj fakturoj, kostoj, ŝuldoj kaj celoj",
  "places nearby, routes and their saved spots, on your google maps key": "proksimaj lokoj, itineroj kaj siaj konservitaj lokoj, per via google maps-ŝlosilo",
  "gesture drawing and japanese": "gesta desegnado kaj la japana",
  "the shared doodle wall": "la komuna skribaĉ-muro",
  "their own scan library": "sia propra skanaĵ-biblioteko",
  "their pings ring at home, chi answers their voice": "riaj sciigoj sonas hejme, chi respondas al ria voĉo",
  "chi can dm your contacts for them": "chi povas sendi privatajn mesaĝojn al viaj kontaktoj por ili",
  "vps panel and bot controls": "vps-panelo kaj robotaj regiloj",
  "every log line": "ĉiu protokola linio",
  "spend and billing": "elspezoj kaj fakturado",
  "api keys, ssh": "api-ŝlosiloj, ssh",
  "this dashboard": "ĉi tiu panelo",
  "tap to upload": "tuŝu por alŝuti",
  "{count} kept": "{count} konservitaj",
  "uploading {n} of {total}": "alŝutante {n} el {total}",
  "scan kept": "skanaĵo konservita",
  "{count} scans kept": "{count} skanaĵoj konservitaj",
  "upload failed": "alŝuto malsukcesis",
  "the brother is scanning": "la brother skanas",
  "scan failed": "skanado malsukcesis",
  "saving {n} of {total}": "konservante {n} el {total}",
  "added to scans": "aldonita al skanaĵoj",
  "could not save that": "ne eblis konservi tion",
  "pdf scan, use download to open it": "pdf-skanaĵo, uzu elŝuti por malfermi ĝin",
  "delete this scan?": "ĉu forigi ĉi tiun skanaĵon?",
  "days apart": "tagojn inter",
  "times a week, any days": "fojojn semajne, iuj ajn tagoj",
  "day of the month": "tago de la monato",
  "added by another part of chix, ticked off there too": "aldonita de alia parto de chix, markita ankaŭ tie",
  "delete {title} and its history?": "ĉu forigi {title} kaj ĝian historion?",
  "no routines": "neniuj rutinoj",
  "ChiX routine": "ChiX-rutino",
  "time for {title}": "tempo por {title}",
  "weekdays": "labortagoj",
  "every {n} days": "ĉiujn {n} tagojn",
  "{n}x a week": "{n}-foje semajne",
  "monthly on day {day}": "monate je la {day}-a",
  "{done}/{times} this week": "{done}/{times} ĉi-semajne",
  "ping {time}": "sciigo {time}",
  "{n}w streak": "serio de {n} sem",
  "{n} streak": "serio de {n}",
  "{title} done": "{title} farita",
  "sticky {date}": "glunoto {date}",
  "saved {time}": "konservita {time}",
  "nothing coming up": "nenio venonta",
  "edit chix task": "redakti chix-taskon",
  "new chix task": "nova chix-tasko",
  "saving...": "konservante...",
  "mark \"{title}\" as done?": "ĉu marki \"{title}\" kiel farita?",
  "urgent": "urĝa",
  "high": "alta",
  "medium": "meza",
  "low": "malalta",
  "{count} shown, updated {time}": "{count} montritaj, ĝisdatigita {time}",
  "nothing pending": "nenio pritraktota",
  "night": "nokto",
  "fog": "nebulo",
  "ember": "ardaĵo",
  "abyss": "abismo",
  "petal": "petalo",
  "peach": "persiko",
  "mint": "mento",
  "lilac": "siringo",
  "starlight": "stellumo",
  "venom": "veneno",
  "pocket": "poŝo",
  "{title} reached, tap done to cross it off": "{title} atingita, tuŝu farita por trastreki ĝin",
  "delete {title}? it won't come back": "ĉu forigi {title}? ĝi ne revenos",
  "done · {n}": "faritaj · {n}",
  "no goals": "neniuj celoj",
  "this one's done, saving keeps it crossed out": "ĉi tiu estas farita, konservi lasas ĝin trastrekita",
  "no goals on the go": "neniuj celoj survoje",
  "add a couple of options": "aldonu kelkajn eblojn",
  "last one standing: {label}": "lasta restanta: {label}",
  "everything's been knocked out": "ĉio estas eliminita",
  "spinning": "turniĝas",
  "the wheel says": "la rado diras",
  "new wheel": "nova rado",
  "knocked out": "eliminita",
  "{n} on the wheel, {out} knocked out": "{n} sur la rado, {out} eliminitaj",
  "{n} on the wheel": "{n} sur la rado",
  "just now": "ĵus",
  "{n}m ago": "antaŭ {n}m",
  "{n}h ago": "antaŭ {n}h",
  "ready": "preta",
  "flick the wheel or press spin": "ŝnuru la radon aŭ premu turni",
  "add a couple of options to spin": "aldonu kelkajn eblojn por turni",
  "a wheel holds {max} options": "rado enhavas {max} eblojn",
  "only {room} fit, a wheel holds {max}": "nur {room} enpaŝas, rado enhavas {max}",
  "my characters": "miaj roluloj",
  "there aren't enough characters yet": "ankoraŭ ne sufiĉas roluloj",
  "which oc": "kiu oc",
  "{name} copy": "{name} kopio",
  "delete the wheel \"{name}\"?": "ĉu forigi la radon \"{name}\"?",
  "yes or no": "jes aŭ ne",
  "what to draw": "kion desegni",
  "dinner": "vespermanĝo",
  "dice": "ĵetkubo",
  "who does it": "kiu faras ĝin",
  "yes": "jes",
  "no": "ne",
  "gesture warm up": "gesta varmigo",
  "portrait": "portreto",
  "an oc": "oc",
  "hands and feet": "manoj kaj piedoj",
  "background": "fono",
  "comic page": "bildstria paĝo",
  "fanart": "fanarto",
  "redraw an old piece": "redesegni malnovan verkon",
  "pizza": "pico",
  "sushi": "suŝio",
  "curry": "kario",
  "burgers": "hamburgeroj",
  "noodles": "nudeloj",
  "cook something": "kuiri ion",
  "yellow": "flava",
  "orange": "oranĝa",
  "lime": "limeo",
  "teal": "tealo",
  "blue": "blua",
  "purple": "purpura",
  "pink": "rozkolora",
  "white": "blanka",
  "black": "nigra",
  "sky": "ĉielblua",
  "slate": "ardezo",
  "edit message": "redakti mesaĝon",
  "delete your message? it goes for everyone": "ĉu forigi vian mesaĝon? ĝi foriĝas por ĉiuj",
  "delete {name}'s message? it goes for everyone": "ĉu forigi la mesaĝon de {name}? ĝi foriĝas por ĉiuj",
  "couldn't delete that": "ne eblis forigi tion",
  "couldn't post that": "ne eblis afiŝi tion",
  "1 message": "1 mesaĝo",
  "{n} messages": "{n} mesaĝoj",
  "someone": "iu",
  "edited": "redaktita",
  "now": "nun",
  "{n}m": "{n} min",
  "{n}h": "{n} h",
  "+{n} more": "+{n} pliaj",
  "couldn't switch": "ne eblis ŝanĝi",
  "switch": "ŝanĝi",
  "profile": "profilo",
  "that isn't a picture": "tio ne estas bildo",
  "picture saved": "bildo konservita",
  "upload picture": "alŝuti bildon",
  "use {name}'s discord picture": "uzi la discord-bildon de {name}",
  "remove picture": "forigi bildon",
  "owned by": "posedata de",
  "remove {name} as an owner": "forigi {name} kiel posedanton",
  "owner removed": "posedanto forigita",
  "another discord user id": "alia discord-uzantidentigilo",
  "discord user id": "discord-uzanta id",
  "add owner": "aldoni posedanton",
  "they can sign in as {name} now": "ili nun povas ensaluti kiel {name}",
  "a discord account that owns an alter can sign in and switch to it, so give the alter's own account here": "discord-konto posedanta alteron povas ensaluti kaj ŝanĝi al ĝi, do donu ĉi tie la propran konton de la alter",
  "she/her, they/them…": "ŝi, ri…",
  "a line about them": "unu linio pri ili",
  "pronouns": "pronomoj",
  "about": "pri",
  "be {name}": "esti {name}",
  "{name} is part of {system}": "{name} estas parto de {system}",
  "back to my profile": "reen al mia profilo",
  "remove {name}? their notes and chats stay on the server if you add them back": "ĉu forigi {name}? ĝiaj notoj kaj babiloj restas en la servilo se vi realdonos ĝin",
  "no alters yet. add the first one above": "ankoraŭ neniuj alteroj. aldonu la unuan supre",
  "{name} added": "{name} aldonita",
  "size: {size}, change": "grando: {size}, ŝanĝi",
  "small": "malgranda",
  "half": "duono",
  "wide": "larĝa",
  "hide": "kaŝi",
  "move earlier": "movi pli frue",
  "move later": "movi pli malfrue",
  "hold to drag": "tenu por treni",
  "arrange home": "aranĝi hejmon",
  "ask chi": "demandi chi",
  "inbox": "enirkesto",
  "gauges": "mezuriloj",
  "message board": "mesaĝtabulo",
  "spin": "turni",
  "cat": "kato",
  "Cat mode": "Kata reĝimo",
  "press ALT P TO EXIT CAT MODE": "premu ALT P POR ELIRI EL KATA REĜIMO",
  "{n} lines": "{n} linioj",
  "live": "viva",
  "no shared boards yet. make one and everyone can draw on it together": "ankoraŭ neniuj komunaj tabuloj. faru unu kaj ĉiuj desegnu kune",
  "no shared boards yet. Fractal can make one": "ankoraŭ neniuj komunaj tabuloj. Fractal povas fari unu",
  "{shared} shared · {mine} yours": "{shared} komunaj · {mine} viaj",
  "could not load the boards": "ne eblis ŝargi la tabulojn",
  "could not make a board": "ne eblis fari tabulon",
  "that board was deleted": "tiu tabulo estis forigita",
  "shared board": "komuna tabulo",
  "board": "tabulo",
  "offline, will send when back": "senrete, sendos kiam reen",
  "that's someone else's, only they can change it": "tio apartenas al alia, nur tiu povas ŝanĝi ĝin",
  "lost the board": "la tabulo perdiĝis",
  "that layer is hidden, show it to draw": "tiu tavolo estas kaŝita, montru ĝin por desegni",
  "that layer is hidden, show it to write": "tiu tavolo estas kaŝita, montru ĝin por skribi",
  "that layer is locked": "tiu tavolo estas ŝlosita",
  "that layer is {who}'s, ask them to let you draw on it": "tiu tavolo estas de {who}, petu permeson desegni sur ĝi",
  "that layer has other people's lines, use the stroke eraser": "tiu tavolo havas liniojn de aliaj, uzu la strekan forviŝilon",
  "pencil found, fingers now move the board": "krajono trovita, fingroj nun movas la tabulon",
  "{n} frames": "{n} kadroj",
  "open": "malfermi",
  "empty": "malplena",
  "this layer is yours": "tiu ĉi tavolo estas via",
  "{who}'s layer": "tavolo de {who}",
  ", open to everyone": ", malferma al ĉiuj",
  ", only they draw here": ", nur tiu desegnas ĉi tie",
  "frames": "kadroj",
  "animate": "animi",
  "layer {n}": "tavolo {n}",
  "delete {name}? you can undo it": "ĉu forigi {name}? vi povas malfari",
  "{name} cleared, undo brings it back": "{name} malplenigita, malfaro revenigas ĝin",
  "{n} frames is the most a layer holds": "tavolo povas havi maksimume {n} kadrojn",
  "delete frame {n}? you can undo it": "ĉu forigi kadron {n}? vi povas malfari",
  "frame {n}": "kadro {n}",
  "frames per second": "kadroj sekunde",
  "fps": "kps",
  "onion skin {state}": "cepa haŭto {state}",
  "shared · look only": "komuna · nur rigardi",
  "shared · live": "komuna · viva",
  "private": "privata",
  "paper {color}": "papero {color}",
  "could not make the picture": "ne eblis fari la bildon",
  "draw something first": "unue desegnu ion",
  "posted to the doodle wall": "afiŝita al la mura gribolaro",
  "could not post it": "ne eblis afiŝi ĝin",
  "delete {name}? this can't be undone": "ĉu forigi {name}? ne eblas malfari",
  "delete {name}? this can't be undone, and it goes for everyone": "ĉu forigi {name}? ne eblas malfari, kaj ĝi malaperas por ĉiuj",
  "could not delete it": "ne eblis forigi ĝin",
  "could not open that board": "ne eblis malfermi tiun tabulon",
  "brush": "peniko",
  "erase": "forviŝi",
  "select": "elekti",
  "shape": "formo",
  "text": "teksto",
  "move": "movi",
  "line": "linio",
  "arrow": "sago",
  "box": "skatolo",
  "ellipse": "elipso",
  "sans": "sen-serifa",
  "serif": "serifa",
  "mono": "egallarĝa",
  "display": "ornama",
  "rub out": "froti for",
  "whole strokes": "tutaj strekoj",
  "duplicate": "duobligi",
  "delete": "forigi",
  "done": "farita",
  "drag to pick, tap one stroke": "trenu por elekti, tuŝetu unu strekon",
  "show": "montri",
  "lock": "ŝlosi",
  "unlock": "malŝlosi",
  "move up": "movi supren",
  "move down": "movi malsupren",
  "stop playing": "halti ludadon",
  "play this layer": "ludi ĉi tiun tavolon",
  "previous frame": "antaŭa kadro",
  "next frame": "sekva kadro",
  "new empty frame": "nova malplena kadro",
  "copy this frame": "kopii ĉi tiun kadron",
  "delete this frame": "forigi ĉi tiun kadron",
  "move this frame earlier": "movi ĉi tiun kadron pli frue",
  "move this frame later": "movi ĉi tiun kadron pli malfrue",
  "plain": "ebena",
  "lines": "linioj",
  "pen": "plumo",
  "pencil": "krajono",
  "ink": "inko",
  "marker": "markilo",
  "glow": "brilo",
  "eraser": "forviŝilo",
  "water": "akvo",
  "air": "aero",
  "spray": "ŝprucilo",
  "coal": "karbo",
  "chalk": "kreto",
  "crayon": "krajono-vaksa",
  "rainbow": "ĉielarko",
  "glitter": "briletaĵo",
  "neon": "neono",
  "boil": "boli",
  "wave": "ondo",
  "flame": "flamo",
  "march": "marŝo",
  "glitch": "paneo",
  "pulse": "pulso",
  "draw": "desegni",
  "paint": "pentri",
  "texture": "teksturo",
  "steady": "stabila",
  "pressure": "premo",
  "soft": "mola",
  "spread": "disvastiĝo",
  "reset this brush": "restarigi ĉi tiun penikon",
  "normal": "normala",
  "multiply": "multipliki",
  "screen": "ekrano",
  "overlay": "surmeto",
  "soft light": "mola lumo",
  "hard light": "forta lumo",
  "darken": "mallumigi",
  "lighten": "heligi",
  "color dodge": "kolora helpo",
  "color burn": "kolora brulo",
  "difference": "diferenco",
  "exclusion": "ekskludo",
  "Goals": "Celoj",
  "me": "mi",
  "Profile": "Profilo",
  "Message board": "Mesaĝtabulo",
  "Roulette": "Ruleto",
  "Whiteboards": "Blanktabuloj",
  "nothing on the board yet": "ankoraŭ nenio sur la tabulo",
  "add to a": "aldoni al",
  "default": "implicita",
  "out of": "el",
  "no goals yet. add one for a chapter to finish, a page count to hit or anything you're working towards": "ankoraŭ neniuj celoj. aldonu unu por ĉapitro finenda, paĝnombro atingenda aŭ io ajn, al kio vi strebas",
  "kana is the standard gojūon table. kanji are the 2,211 jlpt n5 to n1 kanji, meanings and readings from kanjidic2 (edrdg, cc by-sa 4.0), levels from jonathan waller's jlpt lists (cc by)": "kanao estas la norma gojūon-tabelo. kanjioj estas la 2.211 kanjioj de jlpt n5 ĝis n1, signifoj kaj legadoj el kanjidic2 (edrdg, cc by-sa 4.0), niveloj el la jlpt-listoj de jonathan waller (cc by)",
  "bring all back": "revenigi ĉion",
  "slices": "tranĉoj",
  "history": "historio",
  "options": "opcioj",
  "pasting a list adds them all. pizza *3 makes pizza three times as likely, and the weights below set it per slice": "alglui liston aldonas ĉiujn. pizza *3 faras picon trifoje pli probabla, kaj la pezoj sube agordas ĝin por ĉiu tranĉo",
  "no options yet. add a few, or start from a preset in options": "ankoraŭ neniuj elektoj. aldonu kelkajn, aŭ komencu per antaŭagordo en elektoj",
  "shuffle": "miksi",
  "even odds": "egalaj ŝancoj",
  "theme colours": "temaj koloroj",
  "tally": "kalkulo",
  "last spins": "lastaj turnoj",
  "nothing spun on this wheel yet": "ĉi tiu rado ankoraŭ ne turniĝis",
  "after a spin": "post turno",
  "keep it": "teni ĝin",
  "knock it out": "forigi ĝin",
  "knock it out takes each winner off the wheel until you bring them all back, good for turns and tournaments": "forigi ĝin forprenas ĉiun gajninton de la rado ĝis vi revenigas ĉiujn, bone por vicoj kaj turniroj",
  "spin length": "daŭro de turno",
  "quick": "rapida",
  "drama": "dramo",
  "clicks and a jingle": "klakoj kaj ĵinglo",
  "new wheel from": "nova rado el",
  "copy this wheel": "kopii ĉi tiun radon",
  "delete wheel": "forigi radon",
  "winners are picked with your device's secure random, in proportion to each slice's weight, so a slice that looks twice as big really is twice as likely": "gajnintoj estas elektitaj per la sekura hazardo de via aparato, laŭ la pezo de ĉiu tranĉo, do tranĉo duoble pli granda vere estas duoble pli probabla",
  "wheel": "rado",
  "the wheel, flick it to spin": "la rado, ŝnuru ĝin por turni",
  "add options, one per line": "aldonu elektojn, unu po linio",
  "option": "opcio",
  "weight": "pezo",
  "less likely": "malpli probabla",
  "more likely": "pli probabla",
  "less": "malpli",
  "more": "pli",
  "shared": "komunaj",
  "new board": "nova tabulo",
  "mine · private": "mia · privata",
  "no boards of your own yet. only you ever see these": "ankoraŭ neniuj propraj tabuloj. nur vi iam vidas ĉi tiujn",
  "layers": "tavoloj",
  "opacity": "opakeco",
  "blend": "miksmaniero",
  "let others draw on this layer": "lasi aliajn desegni sur ĉi tiu tavolo",
  "brush ·": "peniko ·",
  "pick from the board": "elekti de la tabulo",
  "recent": "lastaj",
  "any colour": "ajna koloro",
  "paper": "papero",
  "only the pencil draws, fingers move and zoom the board": "nur la krajono desegnas, fingroj movas kaj zomas la tabulon",
  "fit": "alĝustigi",
  "save png": "konservi png",
  "post to doodles": "afiŝi al skribaĉoj",
  "two fingers pinch and move, tap two fingers to undo, three to redo. on a keyboard: space drags, [ and ] size, ⌘z undo, k brushes, x erases whole strokes, t text, v select, u shapes, comma and full stop step frames, backslash plays": "du fingroj pinĉas kaj movas, tuŝetu per du fingroj por malfari, per tri por refari. per klavaro: spaco tiras, [ kaj ] grandeco, ⌘z malfari, k penikoj, x forigas tutajn strekojn, t teksto, v elekti, u formoj, komo kaj punkto paŝas kadrojn, retroklino ludas",
  "delete board": "forigi tabulon",
  "Board": "Tabulo",
  "everyone on chi sees this": "ĉiuj en chi vidas tion",
  "nothing on the board yet. post the first line": "ankoraŭ nenio sur la tabulo. afiŝu la unuan linion",
  "who's here": "kiu estas ĉi tie",
  "who is here": "kiu estas ĉi tie",
  "jot to inbox": "noti en enirkeston",
  "say something to everyone": "diru ion al ĉiuj",
  "message for the board": "mesaĝo por la tabulo",
  "finish the chapter 2 sprites…": "fini la spritojn de ĉapitro 2…",
  "why, or what done looks like, optional": "kial, aŭ kia aspektas farita, nedeviga",
  "progress": "progreso",
  "counting what": "kalkulante kion",
  "a board everyone can draw on together": "tabulo, sur kiu ĉiuj povas desegni kune",
  "a board only you can see": "tabulo, kiun nur vi povas vidi",
  "text on the board": "teksto sur la tabulo",
  "back to the boards": "reen al la tabuloj",
  "undo, or tap with two fingers": "malfari, aŭ tuŝetu per du fingroj",
  "redo": "refari",
  "redo, or tap with three fingers": "refari, aŭ tuŝetu per tri fingroj",
  "fit the drawing on screen": "alĝustigi la desegnon al la ekrano",
  "fit to the drawing": "alĝustigi al la desegno",
  "board settings": "agordoj de la tabulo",
  "brush size": "grandeco de peniko",
  "say something to everyone…": "diru ion al ĉiuj…",
  "new alter name": "nomo de nova altero",
  "emoji": "emoĝio",
  "all {count} presets are taken, unpin one first": "ĉiuj {count} antaŭagordoj estas okupitaj, malfiksu unu unue",
  "could not change the owner": "ne eblis ŝanĝi la posedanton",
  "description": "priskribo",
  "groups": "grupoj",
  "large": "granda",
  "layout": "aranĝo",
  "mine {n}": "miaj {n}",
  "owners": "posedantoj",
  "presets": "antaŭagordoj",
  "reversed": "inversigita",
  "sort by": "ordigi laŭ",
  "tap the star on a key to pin it. pins sit above the dock as presets": "tuŝu la stelon sur klavo por alpingli ĝin. alpinglitaj staras super la doko kiel antaŭagordoj",
  "unknown date": "nekonata dato",
  "{name} is not yours any more": "{name} ne plu estas via",
  "{name} is yours now": "{name} nun estas via",
  "Grid": "Krado",
  "Masonry": "Mozaiko",
  "Rows": "Vicoj",
  "Big grid": "Granda krado",
  "Wall": "Muro",
  "Posts": "Afiŝoj",
  "Shuffle": "Miksi",
  "random order, rolled once while it is open": "hazarda ordo, ĵetita unufoje dum ĝi estas malfermita",
  "Newest": "Plej novaj",
  "latest saved first": "laste konservita unue",
  "Oldest": "Plej malnovaj",
  "earliest saved first": "plej frue konservita unue",
  "Most tagged": "Plej etikeditaj",
  "refs with the most tags first": "unue ref. kun plej multaj etikedoj",
  "Undescribed first": "Senpriskribaj unue",
  "what has no description yet comes first": "kio ankoraŭ ne havas priskribon venas unue",
  "By tag": "Laŭ etikedo",
  "grouped under the most used tag": "grupigitaj sub la plej uzata etikedo",
  "By author": "Laŭ aŭtoro",
  "grouped A to Z": "grupigitaj de A ĝis Z",
  "By month": "Laŭ monato",
  "grouped by the month you saved them": "grupigitaj laŭ la monato de konservo",
  "By type": "Laŭ tipo",
  "stills, gifs and clips apart": "bildoj, gif-oj kaj filmetoj aparte",
  "sign in with discord · fractal and pauline": "ensalutu per discord · fractal kaj pauline",
  "continue with discord": "daŭrigi per discord",
  "use": "uzi",
  "Ready when you are.": "Preta kiam vi pretas.",
  "local": "loka",
  "unit": "unuo",
  "chi · online": "chi · enreta",
  "clear": "klara",
  "tip of the day": "konsilo de la tago",
  "another one": "alian",
  "add to a budget": "aldoni al buĝeto",
  "every month": "ĉiun monaton",
  "up next": "sekve",
  "all tasks": "ĉiuj taskoj",
  "nothing due, go draw": "nenio urĝa, iru desegni",
  "routines": "rutinoj",
  "routines done for today": "rutinoj faritaj por hodiaŭ",
  "notes": "notoj",
  "no notes yet": "ankoraŭ neniuj notoj",
  "Tasks": "Taskoj",
  "chix task": "chix-tasko",
  "Notes": "Notoj",
  "note": "noto",
  "scratchpad": "malneto",
  "edit": "redakti",
  "view": "vidi",
  "Refs": "Ref.",
  "random": "hazarde",
  "newest": "plej novaj",
  "oldest": "plej malnovaj",
  "by tag": "laŭ etikedo",
  "stills": "bildoj",
  "moving": "moviĝantaj",
  "chi's description": "priskribo de chi",
  "your note": "via noto",
  "ctrl+enter saves and goes next": "ctrl+enter konservas kaj iras al la sekva",
  "edit tags": "redakti etikedojn",
  "close": "fermi",
  "dialog": "dialogo",
  "post": "afiŝo",
  "next": "sekva",
  "Chi online. What are we drawing?": "Chi enreta. Kion ni desegnu?",
  "what should I work on?": "pri kio mi laboru?",
  "pose refs": "pozo-ref.",
  "pick an oc": "elektu oc",
  "comms": "mendoj",
  "Routines": "Rutinoj",
  "routine": "rutino",
  "every day": "ĉiutage",
  "on these days": "en ĉi tiuj tagoj",
  "every few days": "ĉiujn kelkajn tagojn",
  "times a week": "fojojn semajne",
  "once a month": "unufoje monate",
  "mon": "lun",
  "tue": "mar",
  "wed": "mer",
  "thu": "ĵaŭ",
  "fri": "ven",
  "sat": "sab",
  "sun": "dim",
  "ping at": "sciigo je",
  "paused": "paŭzita",
  "cancel": "nuligi",
  "nothing on today": "nenio hodiaŭ",
  "other days": "aliaj tagoj",
  "no routines yet. add one for a daily sketch, a weekly stream or anything you want to keep up": "ankoraŭ neniuj rutinoj. aldonu unu por ĉiutaga skizo, semajna elsendo aŭ io ajn, kion vi volas daŭrigi",
  "Pings": "Sciigoj",
  "reminder": "memorigilo",
  "alarm": "alarmo",
  "timer": "tempumilo",
  "once": "unufoje",
  "daily": "ĉiutage",
  "weekly": "ĉiusemajne",
  "set": "agordi",
  "no pings yet. set one for a stream, a deadline or a break": "ankoraŭ neniuj sciigoj. agordu unu por elsendo, limdato aŭ paŭzo",
  "Session": "Seanco",
  "focus": "koncentriĝo",
  "start": "komenci",
  "tap the time to type your own, like 40 or 1h30": "tuŝu la tempon por tajpi vian, ekz. 40 aŭ 1h30",
  "0 blocks today": "0 blokoj hodiaŭ",
  "Palette": "Paletro",
  "keep": "konservi",
  "tap a swatch to copy it, hold to toss it": "tuŝu koloron por kopii ĝin, tenu por forĵeti ĝin",
  "Prompts": "Instigoj",
  "save prompt": "konservi instigon",
  "tap a card to copy the whole prompt": "tuŝu karton por kopii la tutan instigon",
  "Comms": "Mendoj",
  "tap a commission to edit it": "tuŝu mendon por redakti ĝin",
  "list": "listo",
  "money": "mono",
  "new commission": "nova mendo",
  "sketch": "skizo",
  "wip": "farata",
  "review": "revizio",
  "reference pics": "referencaj bildoj",
  "this month": "ĉi-monate",
  "this year": "ĉi-jare",
  "to be paid": "pagota",
  "paid by month": "pagita laŭ monato",
  "by client": "laŭ kliento",
  "by status": "laŭ stato",
  "a commission counts on the day it was marked paid. change that day on its card": "mendo kalkuliĝas en la tago, kiam ĝi estis markita pagita. ŝanĝu tiun tagon sur ĝia karto",
  "Budget": "Buĝeto",
  "left": "restas",
  "in and out": "enspezoj kaj elspezoj",
  "monthly by category": "monate laŭ kategorio",
  "debts and goals": "ŝuldoj kaj celoj",
  "one off": "unufoja",
  "monthly": "monata",
  "bills": "fakturoj",
  "costs": "kostoj",
  "debts": "ŝuldoj",
  "goals": "celoj",
  "nothing here yet. add a bill, a debt or a goal above": "ankoraŭ nenio ĉi tie. aldonu fakturon, ŝuldon aŭ celon supre",
  "only you see this unless you switch it on for someone in sharing. paid commissions count as money in": "nur vi vidas tion, krom se vi ŝaltas ĝin por iu en kunhavigo. pagitaj mendoj kalkuliĝas kiel enspezo",
  "Gesture": "Gesto",
  "timed poses, draw fast, the next one drops in on its own": "tempigitaj pozoj, desegnu rapide, la sekva venas memage",
  "source": "fonto",
  "full body": "tuta korpo",
  "my refs": "miaj ref.",
  "each pose": "ĉiu pozo",
  "poses": "pozoj",
  "pause": "paŭzi",
  "skip": "preterpasi",
  "Japanese": "Japana",
  "learning": "lernataj",
  "show answer": "montri respondon",
  "again": "denove",
  "hard": "malfacila",
  "good": "bone",
  "easy": "facila",
  "space shows the answer, 1 to 4 grades it": "spaceto montras la respondon, 1 ĝis 4 taksas ĝin",
  "decks": "kartaroj",
  "new cards a day": "novaj kartoj tage",
  "study, new cards come in this order": "studo, novaj kartoj venas laŭ ĉi tiu ordo",
  "Characters": "Roluloj",
  "chi look": "rigardo de chi",
  "no characters match": "neniu rolulo kongruas",
  "new character": "nova rolulo",
  "name": "nomo",
  "tags, comma separated": "etikedoj, apartigitaj per komoj",
  "sheet picture": "bildo de folio",
  "character file": "dosiero de rolulo",
  "chi saw": "chi vidis",
  "use as picture": "uzi kiel bildon",
  "add pic": "aldoni bildon",
  "drop pic": "forigi bildon",
  "merge": "kunfandi",
  "merge into": "kunfandi en",
  "pick the same character under another name. its pictures and anything this sheet is missing move here, and imports will update this sheet from then on.": "elektu la saman rolulon sub alia nomo. ĝiaj bildoj kaj ĉio, kio mankas al ĉi tiu folio, venas ĉi tien, kaj importoj ĝisdatigos ĉi tiun folion ekde tiam.",
  "Calendar": "Kalendaro",
  "Maps": "Mapoj",
  "near me": "proksime de mi",
  "maps needs a google key": "mapoj bezonas google-ŝlosilon",
  "in console.cloud.google.com make a project and turn on billing": "en console.cloud.google.com kreu projekton kaj ŝaltu fakturadon",
  "turn on": "ŝaltu",
  "and": "kaj",
  "make an api key under credentials, and limit it to those three apis": "kreu api-ŝlosilon sub akreditaĵoj kaj limigu ĝin al tiuj tri api-oj",
  "paste it in setup, keys, google maps. or put it on the server as GOOGLE_MAPS_API_KEY": "algluu ĝin en agordoj, ŝlosiloj, google maps. aŭ metu ĝin sur la servilon kiel GOOGLE_MAPS_API_KEY",
  "open setup": "malfermi agordojn",
  "search this area": "serĉi en ĉi tiu areo",
  "route here": "itinero ĉi tien",
  "route from": "itinero de",
  "remove": "forigi",
  "nearby": "proksime",
  "route": "itinero",
  "best rated": "plej bone taksitaj",
  "most reviews": "plej multaj recenzoj",
  "closest": "plej proksimaj",
  "parking first": "parkejo unue",
  "add where you start and where you're going. places from nearby can go in with their route button": "aldonu de kie vi ekiras kaj kien vi iras. proksimaj lokoj povas eniri per sia itinera butono",
  "from here": "de ĉi tie",
  "home": "hejmo",
  "best order for the middle stops": "plej bona ordo por la mezaj haltoj",
  "plan route": "plani itineron",
  "time": "tempo",
  "distance": "distanco",
  "stops": "haltoj",
  "pins": "pingloj",
  "tap drop a pin, then tap the map where it goes": "tuŝu meti pinglon, poste tuŝu la mapon kie ĝi iru",
  "pin where i am": "pingli kie mi estas",
  "places": "lokoj",
  "star a place from nearby to keep it here": "stelumu proksiman lokon por konservi ĝin ĉi tie",
  "routes": "itineroj",
  "plan a route and save it to keep it here": "planu itineron kaj konservu ĝin por teni ĝin ĉi tie",
  "only you see these unless you switch places and routes on for someone in sharing": "nur vi vidas tion, krom se vi ŝaltas lokojn kaj itinerojn por iu en kunhavigo",
  "tape": "bendo",
  "Scans": "Skanaĵoj",
  "photo": "foto",
  "scan": "skani",
  "on this pc": "en ĉi tiu komputilo",
  "upload all": "alŝuti ĉion",
  "scans the brother left in the inbox folder that the web cannot see yet": "skanaĵoj, kiujn la brother lasis en la enira dosierujo kaj kiujn la retejo ankoraŭ ne vidas",
  "no scans yet. scan on the pc, or snap a photo of a sketch": "ankoraŭ neniuj skanaĵoj. skanu per la komputilo, aŭ fotu skizon",
  "Doodles": "Skribaĉoj",
  "paste": "alglui",
  "no doodles yet. paste one, or add pictures from your phone": "ankoraŭ neniuj skribaĉoj. algluu unu, aŭ aldonu bildojn el via telefono",
  "doodle": "skribaĉo",
  "title": "titolo",
  "drawn by": "desegnita de",
  "day": "tago",
  "characters in it": "roluloj en ĝi",
  "undo mine": "malfari la mian",
  "newer": "pli nova",
  "older": "pli malnova",
  "Server": "Servilo",
  "reload caddy": "reŝargi caddy",
  "memory": "memoro",
  "load": "ŝarĝo",
  "bots up": "aktivaj robotoj",
  "bots": "robotoj",
  "Logs": "Protokoloj",
  "nothing happened yet, it shows up here live": "ankoraŭ nenio okazis, ĝi aperas ĉi tie tuj",
  "billing": "fakturado",
  "month": "monato",
  "chat": "babilo",
  "tags": "etikedoj",
  "key": "ŝlosilo",
  "tagging": "etikedado",
  "budget": "buĝeto",
  "batch": "aro",
  "by model": "laŭ modelo",
  "by person": "laŭ persono",
  "estimates from the token counts claude sends back. billing has the real bill": "taksoj laŭ la ĵetonoj, kiujn claude resendas. fakturado havas la veran fakturon",
  "People": "Homoj",
  "let in": "enlasi",
  "their chi": "ilia chi",
  "yours": "via",
  "everyone talks to chi on your claude key. they never see it, their chats and memory stay their own, and their share of the bill is counted here": "ĉiuj parolas kun chi per via claude-ŝlosilo. ili neniam vidas ĝin, iliaj babiloj kaj memoro restas iliaj, kaj ilia parto de la fakturo kalkuliĝas ĉi tie",
  "let someone in": "enlasi iun",
  "they sign in with discord. if they try before you add them, the page shows them their id to send you": "ili ensalutas per discord. se ili provas antaŭ ol vi aldonas ilin, la paĝo montras al ili ilian id por sendi al vi",
  "only you": "nur vi",
  "Sharing": "Kunhavigo",
  "pick what each person can see. they can only read it, never change it. it shows up next to their own notes, pings and the rest, and their chi can read it too": "elektu, kion ĉiu persono povas vidi. ili povas nur legi ĝin, neniam ŝanĝi. ĝi aperas apud iliaj propraj notoj, sciigoj kaj la cetero, kaj ilia chi ankaŭ povas legi ĝin",
  "shared with you": "kunhavigita kun vi",
  "nobody shares anything with you yet": "ankoraŭ neniu kunhavigas ion kun vi",
  "Setup": "Agordoj",
  "assistant": "asistanto",
  "anthropic api key": "api-ŝlosilo de anthropic",
  "chat model": "babila modelo",
  "ref tagging model": "modelo por etikedi ref.",
  "monthly tagging budget, usd": "monata etikeda buĝeto, usd",
  "tagging pauses once the month's estimate passes the budget. 0 means no cap. claude-haiku-4-5 tags cheaper": "etikedado paŭzas kiam la monata takso superas la buĝeton. 0 signifas sen limo. claude-haiku-4-5 etikedas pli malmultekoste",
  "currency": "valuto",
  "yours only. the sign shown on comms, money stats and the budget. auto reads it from what you type on commissions. it saves as soon as you pick": "nur via. la signo sur mendoj, monaj statistikoj kaj la buĝeto. aŭtomata legas ĝin el tio, kion vi tajpas ĉe mendoj. ĝi konserviĝas tuj kiam vi elektas",
  "log into the plane tab, then connect": "ensalutu en la plane-langeto, poste konektu",
  "open plane, make an api token in profile settings, paste it here": "malfermu plane, kreu api-ĵetonon en profilaj agordoj, algluu ĝin ĉi tie",
  "connect plane": "konekti plane",
  "workspace slug": "nomo de laborspaco",
  "api key": "api-ŝlosilo",
  "load boards": "ŝargi tabulojn",
  "chix bot": "chix-roboto",
  "api url": "api-url",
  "your discord user id": "via discord-uzanta id",
  "browser key, optional": "retumila ŝlosilo, nedeviga",
  "the api key searches places and plans routes from the server. the map itself loads with the browser key if there is one, otherwise the api key. GOOGLE_MAPS_API_KEY on the server wins over this": "la api-ŝlosilo serĉas lokojn kaj planas itinerojn de la servilo. la mapo ŝargiĝas per la retumila ŝlosilo se ekzistas, alie per la api-ŝlosilo. GOOGLE_MAPS_API_KEY sur la servilo havas prioritaton",
  "server": "servilo",
  "bots folder": "dosierujo de robotoj",
  "sudo password": "sudo-pasvorto",
  "ssh host": "ssh-gastiganto",
  "ssh user": "ssh-uzanto",
  "ssh key file": "ssh-ŝlosila dosiero",
  "browser extension": "retumila kromprogramo",
  "paste this into the extension options as the cloud token. it's yours, so saves land as you": "algluu ĉi tion en la agordojn de la kromprogramo kiel nuban ĵetonon. ĝi estas via, do konservaĵoj aperas kiel viaj",
  "chrome: unzip over the old folder and hit reload in chrome://extensions. firefox: open the file in firefox and allow it, it updates itself after that": "chrome: malpaku super la malnovan dosierujon kaj premu reŝargi en chrome://extensions. firefox: malfermu la dosieron en firefox kaj permesu ĝin, poste ĝi ĝisdatiĝas mem",
  "your extension token": "via kromprograma ĵetono",
  "copy": "kopii",
  "new token": "nova ĵetono",
  "links": "ligiloj",
  "one per line as name | url. they open inside the desk app, or in a new tab on the web": "po unu por linio kiel nomo | url. ili malfermiĝas en la labortabla aplikaĵo, aŭ en nova langeto en la retejo",
  "desk": "labortablo",
  "cloud url": "nuba url",
  "cloud token": "nuba ĵetono",
  "chrome extension token": "ĵetono de chrome-kromprogramo",
  "brother scan folder": "brother-skana dosierujo",
  "start with windows": "starti kun windows",
  "security": "sekureco",
  "signs out every phone, tablet and browser that is logged in, including this one. use it if a device was lost or you think someone got in": "elsalutigas ĉiun telefonon, tabulkomputilon kaj retumilon ensalutintan, inkluzive de ĉi tiu. uzu ĝin se aparato perdiĝis aŭ vi pensas, ke iu eniris",
  "log out everywhere": "elsaluti ĉie",
  "pick a look": "elektu aspekton",
  "background pattern": "fona ŝablono",
  "film grain and fog": "filma grajno kaj nebulo",
  "calm motion": "trankvila movado",
  "retry": "reprovi",
  "toss": "forĵeti",
  "logs": "protokoloj",
  "paid on": "pagita je",
  "undo": "malfari",
  "plan": "plano",
  "setup token": "agorda ĵetono",
  "talk to chi": "paroli kun chi",
  "jot into inbox": "noti en enirkeston",
  "whose budget": "kies buĝeto",
  "what kind": "kia speco",
  "what it is": "kio ĝi estas",
  "ask chi…": "demandu al chi…",
  "ask": "demandi",
  "refresh": "refreŝigi",
  "find a task": "trovi taskon",
  "just type, it saves itself": "simple tajpu, ĝi konserviĝas mem",
  "search notes": "serĉi notojn",
  "back": "reen",
  "print": "presi",
  "# heading\n\nmarkdown works, autosave is on": "# titolo\n\nmarkdown funkcias, aŭtomata konservado ŝaltita",
  "search refs, tags, characters": "serĉi ref., etikedojn, rolulojn",
  "tile size": "kahela grandeco",
  "add pictures": "aldoni bildojn",
  "sort the feed": "ordigi la fluon",
  "what you want to remember about this": "kion vi volas memori pri tio",
  "re-index": "reindeksi",
  "open post": "malfermi afiŝon",
  "message chi": "skribi al chi",
  "send": "sendi",
  "a sketch a day…": "skizo tage…",
  "how often": "kiom ofte",
  "how many": "kiom",
  "note, optional": "noto, nedeviga",
  "nudge me about…": "memorigu min pri…",
  "kind": "speco",
  "set the time": "agordi la tempon",
  "minutes, like 40 or 1h30": "minutoj, ekz. 40 aŭ 1h30",
  "reset": "restarigi",
  "another tip": "alia konsilo",
  "pick a colour": "elektu koloron",
  "name, like sitting nsfw": "nomo, ekz. sidanta nsfw",
  "piece": "verko",
  "client (for the money stats)": "kliento (por la monaj statistikoj)",
  "amount": "sumo",
  "due": "limdato",
  "what they want drawn": "kion ili volas desegnita",
  "previous month": "antaŭa monato",
  "next month": "sekva monato",
  "what is it": "kio ĝi estas",
  "owed": "ŝuldata",
  "category": "kategorio",
  "only refs matching… (optional)": "nur ref. kongruantaj… (nedeviga)",
  "add the characters from zirk.eu/oc": "aldoni la rolulojn el zirk.eu/oc",
  "add the characters from the discord character channel": "aldoni la rolulojn el la discord-kanalo de roluloj",
  "chi looks at character pictures and writes tags and a line about each, so she picks better characters and refs": "chi rigardas bildojn de roluloj kaj verkas etikedojn kaj linion pri ĉiu, por ke ŝi elektu pli bonajn rolulojn kaj ref.",
  "search name, race, likes, fetishes…": "serĉi nomon, rason, ŝataĵojn, fetiĉojn…",
  "search characters…": "serĉi rolulojn…",
  "reload": "reŝargi",
  "add an event": "aldoni eventon",
  "map": "mapo",
  "name it: studio, mum's, good parking": "nomu ĝin: studio, ĉe panjo, bona parkejo",
  "a note, optional": "noto, nedeviga",
  "colour": "koloro",
  "sushi, art supplies, an address": "suŝio, artaj provizoj, adreso",
  "how far": "kiom malproksime",
  "add a stop: address, postcode or place": "aldoni halton: adreso, poŝtkodo aŭ loko",
  "add stop": "aldoni halton",
  "download": "elŝuti",
  "add the picture on your clipboard, or press ctrl+v": "aldonu la bildon el via tondujo, aŭ premu ctrl+v",
  "search title, artist, character, tag…": "serĉi titolon, artiston, rolulon, etikedon…",
  "untitled": "sentitola",
  "type a name to add a character": "tajpu nomon por aldoni rolulon",
  "count a fap": "kalkuli fap",
  "console.anthropic.com, api keys": "console.anthropic.com, api-ŝlosiloj",
  "the part after the domain": "la parto post la domajno",
  "maps javascript, places (new) and routes": "maps javascript, places (new) kaj routes",
  "only if the map should load with its own key": "nur se la mapo ŝargiĝu per sia propra ŝlosilo",
  "dock": "doko",
  "find a tool or place": "trovu ilon aŭ lokon",
  "what needs doing?": "kion oni devas fari?",
  "optional notes": "nedevigaj notoj",
  "index": "indekso",
  "mark done": "marki farita",
  "status": "stato",
  "link a task": "ligi taskon",
  "find a plane or chix task": "trovu plane- aŭ chix-taskon",
  "take back the last one": "malfari la lastan",
  "take out": "elpreni",
  "tasks": "taskoj",
  "Today": "Hodiaŭ",
  "refs": "ref.",
  "References": "Referencoj",
  "feed": "fluo",
  "describe": "priskribi",
  "Ask ChiX": "Demandu al ChiX",
  "gesture": "gesto",
  "Gesture drawing": "Gesta desegnado",
  "Session timer": "Seanca tempumilo",
  "palette": "paletro",
  "prompts": "instigoj",
  "Commissions": "Mendoj",
  "ocs": "oc-oj",
  "maps": "mapoj",
  "calc": "kalk",
  "Calculator": "Kalkulilo",
  "doodles": "skribaĉoj",
  "scans": "skanaĵoj",
  "Claude usage": "Uzo de Claude",
  "people": "homoj",
  "share": "kunhavigi",
  "setup": "agordoj",
  "keys": "ŝlosiloj",
  "themes": "temoj",
  "system": "sistemo",
  "Home": "Hejmo",
  "Plan": "Plano",
  "Practice": "Praktiko",
  "Ledger": "Kontoj",
  "Library": "Biblioteko",
  "Core": "Kerno",
  "language": "lingvo",
  "yours only. the app's words and chi's replies follow it. it saves as soon as you pick": "nur via. la vortoj de la aplikaĵo kaj la respondoj de chi sekvas ĝin. ĝi konserviĝas tuj kiam vi elektas",
  "Quick note": "Rapida noto",
  "Reminders": "Memorigiloj",
  "Ubuntu helpers": "Ubuntu-helpiloj",
  "Quit": "Eliri",
  "open {name}": "malfermi {name}",
  "sort": "ordigo",
  "this one is mine": "ĉi tiu estas mia",
  "reverse the order": "inversigi la ordon",
  "filter": "filtrilo",
  "{name} can sign in now. they start with chi, notes, pings, routines and goals": "{name} nun povas ensaluti. ili komencas per chi, notoj, sciigoj, rutinoj kaj celoj",
  "no type": "sen tipo",
  "new type": "nova tipo",
  "no price": "sen prezo",
  "{n} open": "{n} malfermitaj",
  "settled": "kvitigita",
  "{amount} owed": "ŝuldas {amount}",
  "{amount} credit": "{amount} da kredito",
  "even": "kvita",
  "take this back": "malfari ĉi tion",
  "{paid} paid · {owed} still owed": "{paid} pagita · restas {owed}",
  "{paid} paid, settled": "{paid} pagita, kvitigita",
  "from credit": "el kredito",
  "use {amount} credit": "uzi {amount} da kredito",
  "pay {amount} in full": "pagi {amount} tute",
  "{n} characters": "{n} roluloj",
  "{n} references": "{n} referencoj",
  "take off": "forigi",
  "{n} saved": "{n} konservitaj",
  "default currency": "implicita valuto",
  "chi is looking...": "chi rigardas...",
  "let chi describe them": "lasi chi priskribi ilin",
  "add a character": "aldoni rolulon",
  "{amount} is over what is owed. keep it as credit for {client}?": "{amount} superas la ŝuldon. ĉu teni ĝin kiel kredito por {client}?",
  "payment added": "pago aldonita",
  "credit added": "kredito aldonita",
  "{owed} owed": "ŝuldas {owed}",
  "clients": "klientoj",
  "rates": "tarifoj",
  "pay": "pagi",
  "payment": "pago",
  "use credit": "uzi kredito",
  "add credit": "aldoni kredito",
  "owed to you": "ŝuldata al vi",
  "credit held": "tenata kredito",
  "add starter set": "aldoni bazajn tipojn",
  "voice": "voĉo",
  "tune": "agordi",
  "tune {name}": "agordi {name}",
  "items shown": "montrataj eroj",
  "cozy": "aera",
  "whole home: spacing": "la tuta hejmo: interspaco",
  "whole home: columns (wide screens)": "la tuta hejmo: kolumnoj (larĝaj ekranoj)",
  "this browser can't listen, type here instead": "ĉi tiu retumilo ne povas aŭskulti, skribu ĉi tie",
  "added to your inbox": "aldonita al via enirkesto",
  "saved as {name}": "konservita kiel {name}",
  "sent to chi": "sendita al chi",
  "copied": "kopiita",
  "open in notes": "malfermi en notoj",
  "no pings waiting": "neniu memorigo atendas",
  "tap the mic and talk, or type": "tuŝu la mikrofonon kaj parolu, aŭ tajpu",
  "mic blocked": "mikrofono blokita",
  "could not hear": "nenio aŭdiĝis",
  "dictate": "diktadi",
  "study": "studi",
  "pin to home": "alpingli al hejmo",
  "pinned to home, press to unpin": "alpinglita al hejmo, premu por malalpingli",
  "pin {name} to home": "alpingli {name} al hejmo",
  "unpin {name} from home": "malalpingli {name} de hejmo",
  "{count} pins is the limit, unpin one first": "la limo estas {count} pingloj, unue malalpingli unu",
  "Tier lists": "Rangaj listoj",
  "new tier list": "nova ranga listo",
  "no tier lists yet. make one, add pictures and rank them": "ankoraŭ neniu ranga listo. kreu unu, aldonu bildojn kaj ordigu ilin",
  "back to my tier lists": "reen al miaj rangaj listoj",
  "tier list title": "titolo de la ranga listo",
  "the link to this tier list": "la ligilo al ĉi tiu ranga listo",
  "stop sharing": "ĉesi kunhavigi",
  "tiers": "rangoj",
  "not ranked": "ne ordigitaj",
  "pictures not ranked yet": "bildoj ankoraŭ ne ordigitaj",
  "add some pictures to start. drop them here, paste them, or pick them from your files": "aldonu bildojn por komenci. faligu ilin ĉi tie, algluu ilin aŭ elektu el viaj dosieroj",
  "every picture is ranked": "ĉiuj bildoj estas ordigitaj",
  "the picked picture": "la elektita bildo",
  "name of this picture": "nomo de ĉi tiu bildo",
  "name it": "nomu ĝin",
  "unrank": "malordigi",
  "add tier": "aldoni rangon",
  "put everything back": "remeti ĉion",
  "save picture": "konservi bildon",
  "delete list": "forigi liston",
  "tier": "rango",
  "remove this tier": "forigi ĉi tiun rangon",
  "pictures in a removed tier go back to the tray": "bildoj de forigita rango revenas al la pleto",
  "ranked": "ordigitaj",
  "link on": "ligilo aktiva",
  "could not load the tier lists": "ne eblis ŝargi la rangajn listojn",
  "could not make a tier list": "ne eblis krei rangan liston",
  "could not open that tier list": "ne eblis malfermi tiun rangan liston",
  "picture": "bildo",
  "in tier {name}": "en rango {name}",
  "in the unranked tray": "en la pleto de neordigitaj",
  "place the picked picture in tier {name}": "meti la elektitan bildon en rangon {name}",
  "tier {name}, {count} pictures, press to change it": "rango {name}, {count} bildoj, premu por ŝanĝi",
  "tier {name}": "rango {name}",
  "move tier {name} up": "movi rangon {name} supren",
  "move tier {name} down": "movi rangon {name} malsupren",
  "tier {name} moved to row {row}": "rango {name} movita al vico {row}",
  "now tap a tier to place it, or drag it there": "nun tuŝu rangon por meti ĝin, aŭ trenu ĝin tien",
  "drag a picture to a tier, or tap it and then tap the tier": "trenu bildon al rango, aŭ tuŝu ĝin kaj poste tuŝu la rangon",
  "position {n}": "pozicio {n}",
  "tier removed, its pictures are back in the tray": "rango forigita, ĝiaj bildoj revenis al la pleto",
  "a tier list holds {count} pictures": "ranga listo povas teni {count} bildojn",
  "those are not pictures": "tiuj ne estas bildoj",
  "adding pictures {done} of {total}": "aldonante bildojn {done} el {total}",
  "{count} pictures added": "{count} bildoj aldonitaj",
  "could not add those": "ne eblis aldoni ilin",
  "link": "ligilo",
  "link is on, anyone who has it can look at this list": "la ligilo estas aktiva, kiu ajn havas ĝin povas vidi ĉi tiun liston",
  "link is off": "la ligilo estas malaktiva",
  "could not change the link": "ne eblis ŝanĝi la ligilon",
  "link copied": "ligilo kopiita",
  "press copy on your keyboard to copy the link": "uzu kopion per via klavaro por kopii la ligilon",
  "every picture is back in the tray": "ĉiuj bildoj revenis al la pleto",
  "Music": "Muziko",
  "car mode": "aŭta reĝimo",
  "seek": "serĉi",
  "previous song": "antaŭa kanto",
  "next song": "sekva kanto",
  "repeat off": "ripeto malŝaltita",
  "repeat one song": "ripeti unu kanton",
  "repeat everything": "ripeti ĉion",
  "volume": "laŭteco",
  "vol": "laŭt",
  "library": "biblioteko",
  "songs": "kantoj",
  "playlists": "ludlistoj",
  "new playlist": "nova ludlisto",
  "rename playlist": "renomi ludliston",
  "paste a youtube link": "algluu ligilon de youtube",
  "get it": "akiri ĝin",
  "upload mp3 or m4a files": "alŝuti mp3 aŭ m4a dosierojn",
  "youtube links are downloaded on the server into your own library. a playlist link brings every song, up to 40. files can also be dropped on this page": "ligiloj de youtube estas elŝutataj en la servilo al via propra biblioteko. ligilo de listo alportas ĉiujn kantojn, ĝis 40. vi ankaŭ povas faligi dosierojn sur ĉi tiu paĝo",
  "downloads": "elŝutoj",
  "search songs": "serĉi kantojn",
  "back to playlists": "reen al ludlistoj",
  "rename or delete this playlist": "renomi aŭ forigi ĉi tiun ludliston",
  "song": "kanto",
  "change cover": "ŝanĝi kovrilon",
  "remove cover": "forigi kovrilon",
  "artist": "artisto",
  "album": "albumo",
  "downloaded from youtube": "elŝutita el youtube",
  "delete this song": "forigi ĉi tiun kanton",
  "delete playlist": "forigi ludliston",
  "open the music player": "malfermi la ludilon",
  "could not load the music": "ne eblis ŝargi la muzikon",
  "nothing playing": "nenio ludiĝas",
  "unknown artist": "nekonata artisto",
  "pick a song or add one": "elektu kanton aŭ aldonu unu",
  "details for {name}": "detaloj de {name}",
  "{count} songs": "{count} kantoj",
  "this playlist is empty. open a song's details to add it here": "ĉi tiu ludlisto estas malplena. malfermu detalojn de kanto por aldoni ĝin ĉi tie",
  "no playlists yet": "ankoraŭ neniu ludlisto",
  "nothing matches that": "nenio kongruas",
  "no songs yet. add a youtube link or upload some files": "ankoraŭ neniu kanto. aldonu ligilon de youtube aŭ alŝutu dosierojn",
  "could not get it": "ne eblis akiri ĝin",
  "downloading from youtube is not set up on this server yet. uploads work. whoever runs the server needs to install yt-dlp": "elŝuto el youtube ankoraŭ ne estas agordita en ĉi tiu servilo. alŝutoj funkcias. kiu prizorgas la servilon devas instali yt-dlp",
  "that is not a youtube link": "tio ne estas ligilo de youtube",
  "added to the downloads": "aldonita al la elŝutoj",
  "could not start that": "ne eblis komenci tion",
  "use mp3, m4a, ogg, wav or flac files": "uzu dosierojn mp3, m4a, ogg, wav aŭ flac",
  "adding {done} of {total}: {name}": "aldonante {done} el {total}: {name}",
  "could not add it": "ne eblis aldoni ĝin",
  "{count} songs added": "{count} kantoj aldonitaj",
  "added to {name}": "aldonita al {name}",
  "taken out of {name}": "forigita el {name}",
  "could not change the cover": "ne eblis ŝanĝi la kovrilon",
  "delete the playlist {name}? the songs stay in your library": "ĉu forigi la ludliston {name}? la kantoj restas en via biblioteko",
  "all songs": "ĉiuj kantoj",
  "shuffle everything": "miksi ĉion",
  "could not play {name}": "ne eblis ludi {name}",
  "leaderboard": "rangotabulo",
  "medals": "medaloj",
  "draw today": "desegnu hodiaŭ",
  "suggestions": "sugestoj",
  "achievements": "atingoj",
  "points": "poentoj",
  "shine": "brilo",
  "rank": "rango",
  "ranks": "rangoj",
  "exercise": "ekzerco",
  "draw a ref": "desegni referencon",
  "another": "alia",
  "lesson": "leciono",
  "other three": "aliaj tri",
  "done, I drew it": "finite, mi desegnis",
  "drawn today, nice": "desegnite hodiaŭ, bone",
  "no references to pick from yet": "ankoraŭ neniuj referencoj por elekti",
  "how could chix be better?": "kiel plibonigi chix?",
  "no suggestions yet, be the first": "ankoraŭ neniuj sugestoj, estu la unua",
  "nobody has points yet": "ankoraŭ neniu havas poentojn",
  "earn points to win your first medal": "gajnu poentojn por gajni vian unuan medalon",
  "show me on the leaderboard": "montri min en la rangotabulo",
  "of {n}": "el {n}",
  "{done} of {total} achievements": "{done} el {total} atingoj",
  "{n} points": "{n} poentoj",
  "{n} need a polish": "{n} bezonas poluradon",
  "all shining": "ĉiuj brilas",
  "needs a polish": "bezonas poluradon",
  "shining": "brilas",
  "keep going to find out": "daŭrigu por malkovri",
  "{n} min": "{n} min",
  "challenge done, {n} day streak": "defio farita, serio de {n} tagoj",
  "pick this reference": "elekti ĉi tiun referencon",
  "vote": "voĉdoni",
  "fewer": "malpli",
  "planned": "planita",
  "declined": "malakceptita",
  "achievement: {name} +{points}": "atingo: {name} +{points}",
  "medal earned: {name}": "medalo gajnita: {name}",
  "Upskill": "Lerni",
  "upskill": "lerni",
  "medals gather grime every day. rub one with a finger or the mouse until it shines. a dirty medal adds less shine to your score": "medaloj malpuriĝas ĉiutage. froti unu per fingro aŭ muso ĝis ĝi brilas. malpura medalo aldonas malpli da brilo al via poentaro",
  "score is points plus shine, and shine is what your medals add while they are clean": "poentaro estas poentoj plus brilo, kaj brilo estas tio, kion viaj medaloj aldonas dum ili estas puraj",
  "music": "muziko",
  "calendar": "kalendaro",
  "session timer": "tempigilo",
  "prompt": "ideo",
  "calculator": "kalkulilo",
  "doodle wall": "skribaĉa muro",
  "whiteboards": "blankaj tabuloj",
  "references": "referencoj",
  "characters": "roluloj",
  "tier lists": "tavollistoj",
  "gesture drawing": "gesta desegnado",
  "claude usage": "uzo de claude",
  "sharing": "kunhavigo",
  "{n} songs": "{n} kantoj",
  "tap play to shuffle your library": "premu ludi por miksi vian bibliotekon",
  "no colours saved yet": "ankoraŭ neniuj koloroj konservitaj",
  "no prompts saved yet": "ankoraŭ neniuj ideoj konservitaj",
  "{owed} owed to you": "{owed} ŝuldataj al vi",
  "nobody owes you": "neniu ŝuldas al vi",
  "no open commissions": "neniuj malfermaj mendoj",
  "calculate": "kalkuli",
  "make a wheel in spin first": "unue faru radon en turni",
  "no saved places yet": "ankoraŭ neniuj lokoj konservitaj",
  "no scans yet": "ankoraŭ neniuj skanaĵoj",
  "the wall is empty": "la muro estas malplena",
  "no whiteboards yet": "ankoraŭ neniuj blankaj tabuloj",
  "no references yet": "ankoraŭ neniuj referencoj",
  "no characters yet": "ankoraŭ neniuj roluloj",
  "{ranked} of {count} ranked": "{ranked} el {count} vicigitaj",
  "no tier lists yet": "ankoraŭ neniuj tavollistoj",
  "5 × 30s": "5 × 30 s",
  "10 × 1m": "10 × 1 min",
  "20 × 2m": "20 × 2 min",
  "a warm up from the pose library, pick a length": "varmigo per la pozbiblioteko, elektu daŭron",
  "{points} points · rank {rank}": "{points} poentoj · rango {rank}",
  "nothing logged": "nenio protokolita",
  "of ${budget} this month": "el ${budget} ĉi-monate",
  "up": "funkcias",
  "nobody added yet": "neniu aldonita ankoraŭ",
  "{out} things shared by you, {incoming} people share with you": "{out} aferoj kunhavigitaj de vi, {incoming} homoj kunhavigas kun vi",
  "your medals": "viaj medaloj",
  "change the drawing": "ŝanĝi la desegnaĵon",
  "add a screenshot or photo of your drawing": "aldonu ekrankopion aŭ foton de via desegnaĵo",
  "your drawing": "via desegnaĵo",
  "a line about it (optional)": "linio pri ĝi (nedeviga)",
  "share on the feed, +{n} points": "dividi en la fluo, +{n} poentoj",
  "add your drawing first": "aldonu vian desegnaĵon unue",
  "finish without sharing": "fini sen dividi",
  "you drew today and shared it, nice": "vi desegnis hodiaŭ kaj dividis, bone",
  "you can still share your drawing for +{n} points": "vi ankoraŭ povas dividi vian desegnaĵon por +{n} poentoj",
  "worth +{done} points, and +{more} more when you share your drawing, plus any achievement it unlocks": "valoras +{done} poentojn, kaj +{more} pli kiam vi dividas vian desegnaĵon, plus iujn atingojn",
  "add your drawing": "aldoni vian desegnaĵon",
  "drew a reference": "desegnis referencon",
  "drew {title}": "desegnis {title}",
  "finished draw today with a reference": "finis desegnu hodiaŭ per referenco",
  "finished draw today: {title}": "finis desegnu hodiaŭ: {title}",
  "unlocked {names}": "malŝlosis {names}",
  "earned {names}": "gajnis {names}",
  "finished today's cards": "finis la hodiaŭajn kartojn",
  "{n} answered": "{n} respondoj",
  "open the drawing": "malfermi la desegnaĵon",
  "the reference": "la referenco",
  "cheer": "brave",
  "drawings": "desegnaĵoj",
  "studying": "studado",
  "my upskilling": "mia lernado",
  "day streak": "serio de tagoj",
  "answered today": "respondite hodiaŭ",
  "start a language in upskill and it shows up here": "komencu lingvon en lerni kaj ĝi aperos ĉi tie",
  "{n} posts": "{n} afiŝoj",
  "nothing on the feed yet, finish draw today or a day of cards": "ankoraŭ nenio en la fluo, finu desegnu hodiaŭ aŭ tagon de kartoj",
  "nothing on the feed yet": "ankoraŭ nenio en la fluo",
  "upskilling feed": "lerna fluo",
  "Draw today": "Desegnu hodiaŭ",
  "Feed": "Fluo",
  "Modern Chinese": "Moderna ĉina",
  "Classical Chinese": "Klasika ĉina",
  "modern chinese words": "vortoj de moderna ĉina",
  "classical chinese words": "vortoj de klasika ĉina",
  "a new exercise every day, in the style of the drawabox drills and other classic warm ups. draw a ref picks three references from the shared library to choose from. drawings you share show up on the feed": "nova ekzerco ĉiutage, laŭ la stilo de la drawabox-ekzercoj kaj aliaj klasikaj varmigoj. desegni referencon proponas tri referencojn el la komuna biblioteko. dividitaj desegnaĵoj aperas en la fluo",
  "pick a length, draw the poses, then come back here and press done": "elektu daŭron, desegnu la pozojn, poste revenu ĉi tien kaj premu finite",
  "session started today, {n} poses picked": "seanco komencita hodiaŭ, {n} pozoj elektitaj",
  "no gesture session started today yet": "ankoraŭ neniu gesta seanco komencita hodiaŭ",
  "start a gesture session first": "unue komencu gestan seancon",
  "finished draw today with a gesture session": "finis desegnu hodiaŭ per gesta seanco",
  "drew {n} gesture poses": "desegnis {n} gestajn pozojn",
  "a new exercise every day, in the style of the drawabox drills and other classic warm ups. draw a ref picks three references from the shared library to choose from. gesture starts a timed session from the pose library. drawings you share show up on the feed": "nova ekzerco ĉiutage, laŭ la stilo de la drawabox-ekzercoj kaj aliaj klasikaj varmigoj. desegni referencon proponas tri referencojn el la komuna biblioteko. gesta komencas tempigitan seancon el la pozbiblioteko. dividitaj desegnaĵoj aperas en la fluo",
  "open the reference": "malfermi la referencon",
  "don't draw this one": "ne desegni ĉi tiun",
  "draw this one": "desegni ĉi tiun",
  "picked": "elektita",
  "pick": "elekti",
  "favorite": "ŝatata",
  "favorites": "ŝatataj",
  "to do": "farotaj",
  "doing": "farata",
  "blocked": "blokita",
  "move to": "movi al",
  "status: {status}": "stato: {status}",
  "hidden here, still open in plane": "kaŝita ĉi tie, ankoraŭ malfermita en plane",
  "sure?": "certe?",
  "delete task": "forigi taskon",
  "hide task": "kaŝi taskon",
  "hide the hidden": "kaŝi la kaŝitajn",
  "show hidden ({count})": "montri kaŝitajn ({count})",
  "restore": "restarigi",
  "nothing here": "nenio ĉi tie",
  "trash": "rubujo",
  "tap the trash can on the card to delete it": "tuŝu la rubujon sur la karto por forigi",
  "set status": "ŝanĝi staton",
  "note (optional)": "noto (nedeviga)",
  "Linked calendars": "Ligitaj kalendaroj",
  "Chi copies these in read only, one way. Changes made here never go back to them.": "Chi kopias ilin nurlege, unudirekte. Ŝanĝoj faritaj ĉi tie neniam reiras al ili.",
  "Name": "Nomo",
  "Calendar link": "Ligilo de kalendaro",
  "Add calendar": "Aldoni kalendaron",
  "Adding": "Aldonante",
  "Proton: Settings, Calendars, Share via link (private). Google: Settings, your calendar, Secret address in iCal format. Apple: Calendar, share, Public calendar, copy link. Outlook: Settings, Shared calendars, Publish a calendar, ICS. Nextcloud: calendar menu, Copy private link.": "Proton: Agordoj, Kalendaroj, Kunhavigi per ligilo (privata). Google: Agordoj, via kalendaro, Sekreta adreso en iCal-formato. Apple: Kalendaro, kunhavigi, Publika kalendaro, kopii ligilon. Outlook: Agordoj, Komunaj kalendaroj, Publikigi kalendaron, ICS. Nextcloud: kalendara menuo, Kopii privatan ligilon.",
  "Let Chi see this calendar": "Lasi Chi vidi ĉi tiun kalendaron",
  "Sync now": "Sinkronigi nun",
  "Syncing": "Sinkronigante",
  "Remove": "Forigi",
  "Tap again to remove": "Tuŝu denove por forigi",
  "never synced": "neniam sinkronigita",
  "{count} min ago": "antaŭ {count} min",
  "{count} h ago": "antaŭ {count} h",
  "{count} d ago": "antaŭ {count} t",
  "synced {when} · {count} events": "sinkronigita {when} · {count} eventoj",
  "last good sync {when}": "lasta bona sinkronigo {when}",
  "could not sync": "ne eblis sinkronigi",
  "could not add that calendar": "ne eblis aldoni tiun kalendaron",
  "that does not look like a calendar link": "tio ne ŝajnas kalendara ligilo",
  "calendar links must start with https:// or webcal://": "ligiloj komenciĝu per https:// aŭ webcal://",
  "that link has a login inside it, use the private share link instead": "tiu ligilo enhavas ensaluton, uzu la privatan kunhavan ligilon",
  "that address is not allowed": "tiu adreso ne estas permesata",
  "that calendar is too big (over 5 MB)": "tiu kalendaro estas tro granda (pli ol 5 MB)",
  "that link did not give a calendar file": "tiu ligilo ne donis kalendaran dosieron",
  "the calendar server took too long": "la kalendara servilo tro malrapidis",
  "could not reach that calendar": "ne eblis atingi tiun kalendaron",
  "that calendar is already linked": "tiu kalendaro jam estas ligita",
  "that is plenty of linked calendars, remove one first": "tio estas multe da ligitaj kalendaroj, unue forigu unu",
  "too many redirects": "tro multaj alidirektoj",
  "the calendar server sent a broken redirect": "la kalendara servilo sendis rompitan alidirekton",
  "otherworld rust": "rusto de la alia mondo",
  "hospital green": "hospitala verdo",
  "y2k aqua": "y2k akvo",
  "vhs blue": "vhs blua",
  "paper zine": "papera zino",
  "cassette": "kasedo",
  "moonlit violet": "lunlumviolo",
  "lime soda": "lima sodo",
  "rose quartz": "rozkvarco",
  "sepia archive": "sepia arkivo",
  "deep sea lab": "profundmara laboratorio",
  "arcade night": "arkada nokto",
  "velvet room": "pluŝa ĉambro",
  "boudoir": "budoaro",
  "latex noir": "lateksa nigro",
  "neon lounge": "neona salono",
  "succubus": "sukubo",
  "honey trap": "mielkaptilo",
  "cherry cola": "ĉerizkolao",
  "after hours": "post la fermo",
  "peeling paint and a rusted siren": "senŝeliĝanta farbo kaj rusta sireno",
  "flickering corridor light, sick green tile": "ekbrilanta koridora lumo, malsana verda kaheloj",
  "glossy bubble blue, 2001 desktop": "briliga veziketblua, labortablo de 2001",
  "tracking lines and a blue no signal screen": "spurlinioj kaj blua ekrano sen signalo",
  "photocopied paper and red marker": "kopiita papero kaj ruĝa markilo",
  "walkman amber, warm brown tape": "ambro de promenludilo, varma bruna bendo",
  "a quiet night in lavender light": "kvieta nokto en lavenda lumo",
  "fizzy lime, bright sticker shop": "bobelanta limo, brila glumarkbutiko",
  "pale pink stone and soft rose": "pala rozkolora ŝtono kaj milda roza",
  "old film stock and brown ink": "malnova filmo kaj bruna inko",
  "bathyscaphe lights and bioluminescent teal": "lumoj de batiskafo kaj bioluma bluverda",
  "cabinet glow, hot pink and electric cyan": "brilo de ludkabineto, vigla rozo kaj elektra cejano",
  "wine velvet curtains and low red light": "vinruĝaj pluŝaj kurtenoj kaj malforta ruĝa lumo",
  "dusty rose, silk and brass lamplight": "polva rozo, silko kaj latuna lampolumo",
  "wet black gloss and a red sliver": "malseka nigra brilo kaj ruĝa strio",
  "magenta tubes in a smoky bar": "magentaj tuboj en fuma drinkejo",
  "blood red, violet shadow, a wicked grin": "sangoruĝa, viola ombro, petola rideto",
  "warm amber, sticky gold and candle smoke": "varma ambro, glua oro kaj kandela fumo",
  "dark fizz, cherry red, diner neon": "malhelaj bobeloj, ĉerizruĝa, neono de manĝejo",
  "midnight indigo and rose city lights": "noktomeza indigo kaj rozaj urbolumoj",
  "otherworld": "alia mondo",
  "y2k": "y2k",
  "mature": "plenaĝa",
  "basic": "baza",
  "japanese": "japana",
  "horror": "hororo",
  "Silkscreen titles over the pixel labels": "titoloj en Silkscreen super la pikselaj etikedoj",
  "Pixelify Sans, a chunky bitmap face": "Pixelify Sans, dika bitmapa tiparo",
  "Share Tech Mono, a thin hud readout": "Share Tech Mono, maldika hud-legaĵo",
  "IBM Plex Mono, a tidy code face": "IBM Plex Mono, ordema kodtiparo",
  "Major Mono Display titles, text in Space Mono": "titoloj en Major Mono Display, teksto en Space Mono",
  "Audiowide titles over the original labels": "titoloj en Audiowide super la originalaj etikedoj",
  "Chakra Petch, angular and techy": "Chakra Petch, angula kaj teknika",
  "Unbounded titles, Lexend text": "titoloj en Unbounded, teksto en Lexend",
  "Syne, wide and art gallery edgy": "Syne, larĝa kaj arta galeria",
  "Monoton titles, a neon sign outline": "titoloj en Monoton, konturo de neona reklamo",
  "Bungee titles, shop sign letters": "titoloj en Bungee, literoj de butika reklamo",
  "Righteous titles, a 70s poster face": "titoloj en Righteous, afiŝa tiparo de la 70aj jaroj",
  "Bebas Neue titles, tall and flat": "titoloj en Bebas Neue, altaj kaj platas",
  "Pacifico titles, a surf shop script": "titoloj en Pacifico, skribo de surfbutiko",
  "Fraunces, a soft old style serif": "Fraunces, milda malnovstila serifa",
  "Playfair Display, high contrast and elegant": "Playfair Display, alta kontrasto kaj eleganta",
  "Cormorant Garamond, a delicate book face": "Cormorant Garamond, delikata libra tiparo",
  "Cinzel titles, carved roman capitals": "titoloj en Cinzel, ĉizitaj romiaj majuskloj",
  "Permanent Marker titles, Gloria Hallelujah text": "titoloj en Permanent Marker, teksto en Gloria Hallelujah",
  "Kalam, quick pen handwriting": "Kalam, rapida plumskribo",
  "Dancing Script titles, Kalam text": "titoloj en Dancing Script, teksto en Kalam",
  "Indie Flower, loopy and cheerful": "Indie Flower, buklaĵa kaj gaja",
  "Shadows Into Light, thin felt tip": "Shadows Into Light, maldika feltostifto",
  "Nunito, rounded and calm": "Nunito, ronda kaj trankvila",
  "Quicksand, light and round": "Quicksand, malpeza kaj ronda",
  "Comfortaa, circles and soft curves": "Comfortaa, cirkloj kaj molaj kurboj",
  "Baloo 2, plump and friendly": "Baloo 2, ronda kaj amika",
  "Lexend, wide open and easy to read": "Lexend, malfermita kaj facile legebla",
  "Josefin Sans, vintage geometric": "Josefin Sans, malnovstila geometria",
  "Zen Maru Gothic, round gothic": "Zen Maru Gothic, ronda gotika",
  "Yusei Magic, felt pen marker": "Yusei Magic, feltostifta markilo",
  "Hachi Maru Pop, bubbly pop lettering": "Hachi Maru Pop, bobela pop-skribo",
  "Reggae One titles, heavy and loud": "titoloj en Reggae One, pezaj kaj laŭtaj",
  "Creepster titles, dripping horror": "titoloj en Creepster, gutanta hororo",
  "Rubik Glitch titles, a broken signal": "titoloj en Rubik Glitch, rompita signalo",
  "panels and screen": "paneloj kaj ekrano",
  "cursor": "kursoro",
  "panel style": "panela stilo",
  "screen filter": "ekrana filtrilo",
  "mouse cursor": "musa kursoro",
  "cursor pack": "kursora pakaĵo",
  "filter strength": "forto de la filtrilo",
  "adult themes and cursors": "temoj kaj kursoroj por plenkreskuloj",
  "Adult themes and cursors, suggestive but never explicit. Off by default. Only affects your own screen.": "Temoj kaj kursoroj por plenkreskuloj, sugestaj sed neniam eksplicitaj. Defaŭlte malŝaltita. Efikas nur sur via propra ekrano.",
  "adult options on": "plenkreskaj opcioj ŝaltitaj",
  "adult options off": "plenkreskaj opcioj malŝaltitaj",
  "bracket": "krampoj",
  "double line": "duobla linio",
  "window": "fenestro",
  "offset": "ŝovita",
  "stitched": "kudrita",
  "no frame": "sen kadro",
  "night vision": "nokta vido",
  "dream": "sonĝo",
  "grayscale": "grizskalo",
  "commission": "mendo",
  "delete commission": "forigi mendon",
  "Shared with me ({count})": "Kunhavigita kun mi ({count})",
  "sponge": "spongo",
  "cloth": "tuko",
  "locked": "ŝlosita",
  "condition": "stato",
  "holo": "holo",
  "Special": "Speciala",
  "Rusty": "Rustinta",
  "Tarnished": "Makulita",
  "Dull": "Senbrila",
  "Clean": "Pura",
  "Mirror": "Spegula",
  "The Collection": "La kolekto",
  "{n} of {total}": "{n} el {total}",
  "needs polish": "bezonas poluron",
  "fully polished": "tute polurita",
  "a medal you have not found yet": "medalo ankoraŭ ne trovita",
  "Put back in the case": "Remeti en la vitrinon",
  "take the {tool}": "preni la ilon: {tool}",
  "scrape off the rust": "skrapu la rustaĵon",
  "scrub off the grime": "frotu la malpuraĵon",
  "polish it to a shine": "poluru ĝis brilo",
  "That is rust. Scrape it off with the brush first.": "Tio estas rustaĵo. Unue skrapu per la broso.",
  "That is grime. Scrub it off with the sponge first.": "Tio estas malpuraĵo. Unue frotu per la spongo.",
  "Nothing left for the {tool}. Try the {next}.": "Nenio restas por la ilo {tool}. Provu {next}.",
  "Rub the medal with the {tool}. Press space to scrub.": "Frotu la medalon per {tool}. Premu spacon por frotadi.",
  "every area of chix has its own shelf. tap a medal to take it to the workbench and clean it with the brush, the sponge and the cloth. a dirty medal adds less shine to your score": "ĉiu parto de chix havas propran breton. tuŝu medalon por porti ĝin al la laborbenko kaj purigu ĝin per broso, spongo kaj tuko. malpura medalo aldonas malpli da brilo al via poentaro",
  "{count} new medals": "{count} novaj medaloj",
  "Earned for": "Gajnita por",
  "How to earn it": "Kiel gajni ĝin",
  "Date": "Dato",
  "Not earned yet": "Ankoraŭ ne gajnita",
  "{n} {area} points": "{n} poentoj de {area}",
  "Close": "Fermi",
  "{n} medals": "{n} medaloj",
  "{n} shining": "{n} brilaj",
  "{n} rusty": "{n} rustaj",
  "Bronze": "Bronzo",
  "Silver": "Arĝento",
  "Gold": "Oro",
  "Crystal": "Kristalo",
  "Money": "Mono",
  "Menu": "Menuo",
  "menu": "menuo",
  "stations": "stacioj",
  "go to…": "iri al…",
  "places in {name}": "lokoj en {name}",
  "{count} places": "{count} lokoj",
  "search every place": "serĉi ĉie",
  "skip to content": "salti al enhavo",
  "wall": "muro",
  "boards": "tabuloj",
  "moodboard": "etosa tabulo",
  "ref feed": "fluo de referencoj",
  "today at a glance": "la tago unuavide",
  "what to do and when": "kion fari kaj kiam",
  "make art, keep your world": "kreu artaĵojn, prizorgu vian mondon",
  "get better every day": "pliboniĝu ĉiutage",
  "commissions and budget": "mendoj kaj buĝeto",
  "small handy things": "etaj utilaj iloj",
  "run the app": "prizorgi la apon",
  "station tuner. tap for all stations, drag to tune, arrow keys to step": "stacia agordilo. tuŝu por ĉiuj, ŝovu por agordi, sagoj por paŝi",
  "show tasks from": "montri taskojn de",
  "plane tasks": "taskoj de plane",
  "chix bot tasks": "taskoj de la roboto chix",
  "commission tasks": "taskoj de mendoj",
  "on chosen weekdays": "en elektitaj tagoj",
  "a few times a week": "kelkfoje semajne",
  "when": "kiam",
  "just once": "nur unufoje",
  "every week": "ĉiusemajne",
  "type": "tipo",
  "blend mode": "miksa reĝimo",
  "darkening": "mallumigi",
  "lightening": "heligi",
  "compare": "kompari",
  "what to be pinged about": "pri kio memorigi",
  "routine name": "nomo de la rutino",
  "note title": "titolo de la noto",
  "note body": "teksto de la noto",
  "task name": "nomo de la tasko",
  "event title": "titolo de la evento",
  "piece name": "nomo de la peco",
  "client": "kliento",
  "price": "prezo",
  "images": "bildoj",
  "audio files": "sondosieroj",
  "cover image": "kovrilo",
  "joined Chi. say hi!": "aliĝis al Chi. Salutu!",
  "started a shared whiteboard: {title}": "komencis komunan blankan tabulon: {title}",
  "made a tier list public: {title}": "publikigis rangoliston: {title}",
  "joined": "aliĝo",
  "medal": "medalo",
  "art": "arto",
  "open the picture": "malfermi la bildon",
  "comments": "komentoj",
  "comment": "komenti",
  "write a comment": "skribu komenton",
  "edit post": "redakti afiŝon",
  "delete your post? it goes for everyone": "ĉu forigi vian afiŝon? ĝi malaperas por ĉiuj",
  "delete {name}'s post? it goes for everyone": "ĉu forigi la afiŝon de {name}? ĝi malaperas por ĉiuj",
  "posts": "afiŝoj",
  "events": "eventoj",
  "nothing on the feed yet. post the first one": "ankoraŭ nenio. afiŝu la unuan",
  "post to the feed": "afiŝi en la fluo",
  "write a post": "skribu afiŝon",
  "couldn't open that picture": "ne eblis malfermi tiun bildon",
  "a picture needs to be a png, jpeg, webp or gif": "la bildo devas esti png, jpeg, webp aŭ gif",
  "that post is gone": "tiu afiŝo ne plu ekzistas",
  "you can only edit your own posts": "vi povas redakti nur viajn afiŝojn",
  "that isn't yours to remove": "tion ne vi povas forigi",
  "this post has enough comments": "tiu afiŝo havas sufiĉe da komentoj",
  "couldn't remove that": "ne eblis forigi tion",
  "board name": "nomo de la tabulo",
  "sure? tap again": "ĉu certe? tuŝu denove",
  "{name}, plane project": "{name}, plane-projekto",
  "rename or delete {name}": "renomi aŭ forigi {name}",
  "{count} tasks on this board. Deleting the board moves them to {inbox}.": "{count} taskoj sur ĉi tiu tabulo. Forigo movas ilin al {inbox}.",
  "board deleted, its tasks are back in {inbox}": "tabulo forigita, ĝiaj taskoj revenis al {inbox}"
};
